export const caTranslatedStrings = {
    "category_task_model": "Model de tasca",
    "category_warm_up": "Preparació del tema / Escalfament",
    "category_developing": "Desenvolupament de coneixements / habilitats",
    "category_vocabulary": "Vocabulari i expressions",
    "category_custom": "Personalitzat",
    "category_task_repetition": "Repetició de tasca / Tasca de seguiment",
    "category_explicit_explanation": "Explicació explícita",
    "category_reflection": "Reflexió",
    "category_written_oral": "D'escrit a oral / d'oral a escrit",
    "activity_listening": "Comprensió oral",
    "activity_watching": "Visionat",
    "activity_reading": "Lectura",
    "activity_speaking": "Expressió oral",
    "activity_writing": "Escriptura",
    "activity_interaction": "Interacció",
    "activity_exercise": "Exercici",
    "activity_game": "Joc",
    "Type of pre/post-task": "Tipus de pre/post-tasca",
    "Activity types": "Tipus d'activitat",
    "Select at least one activity type": "Selecciona almenys un tipus d'activitat",
    "Short text": "Text breu",
    "Description (optional)": "Descripció (opcional)",
    "Edit interaction design": "Edita el disseny d'interacció",
    "Edit Interaction": "Edita la interacció",
    "The exercise designer will be available soon.": "El dissenyador d'exercicis estarà disponible aviat.",
    "Edit exercise": "Edita l'exercici",
    "Exercise configured": "Exercici configurat",
    "No exercise yet": "Encara no hi ha exercici",
    "Exercise name": "Nom de l'exercici",
    "Default grade": "Puntuació per defecte",
    "Penalty": "Penalització",
    "Default grade help": "Punts que val la pregunta a Moodle (la seva 'puntuació per defecte'). Normalment 1.",
    "Penalty help": "Fracció que es descompta per cada reintent fallat — només en el mode interactiu/adaptatiu de Moodle. Per defecte: 1/3 (0,3333).",
    "Question grade override help": "Punts per a aquesta pregunta. Deixa-ho buit per usar el valor per defecte de l'exercici.",
    "Question penalty override help": "Penalització per a aquesta pregunta. Deixa-ho buit per usar el valor per defecte de l'exercici.",
    "Exercise type": "Tipus d'exercici",
    "exercise_type_questions": "Preguntes independents",
    "exercise_type_cloze": "Cloze (buits dins el text)",
    "The Cloze editor is coming next.": "L'editor Cloze arribarà aviat.",
    "Cloze text": "Text del Cloze",
    "Select a word and turn it into a gap:": "Selecciona una paraula i fes-ne un buit:",
    "Make gap": "Fes buit",
    "Select a word in the text first.": "Primer selecciona una paraula al text.",
    "Gap": "Buit",
    "Clue": "Pista",
    "Correct answer": "Resposta correcta",
    "Alternatives": "Alternatives",
    "Add alternative": "Afegeix alternativa",
    "cloze_gap_gapfill": "Omplir buit",
    "cloze_gap_multichoice": "Opció múltiple",
    "cloze_gap_truefalse": "Cert / Fals",
    "Add question": "Afegeix pregunta",
    "No questions yet.": "Encara no hi ha preguntes.",
    "Statement": "Enunciat",
    "exercise_qtype_shortanswer": "Resposta breu",
    "exercise_qtype_essay": "Resposta oberta",
    "exercise_qtype_truefalse": "Cert / Fals",
    "exercise_qtype_multichoice": "Opció múltiple",
    "exercise_qtype_matching": "Emparellament",
    "exercise_qtype_ordering": "Ordenar",
    "Open answer — no auto-correction.": "Resposta oberta — sense auto-correcció.",
    "True": "Cert",
    "False": "Fals",
    "Accepted answers": "Respostes acceptades",
    "Answer": "Resposta",
    "Add answer": "Afegeix resposta",
    "Case sensitive": "Distingeix majúscules",
    "Allow multiple correct answers": "Permet més d'una resposta correcta",
    "Add option": "Afegeix opció",
    "Matching pairs": "Parelles a emparellar",
    "Left": "Esquerra",
    "Right": "Dreta",
    "Add pair": "Afegeix parella",
    "Items in correct order": "Elements en l'ordre correcte",
    "Add item": "Afegeix element",
    "Exercise saved": "Exercici desat",
    "Saving...": "Desant...",
    "Export": "Exportar",
    "Moodle (XML)": "Moodle (XML)",
    "Edit Pre-Task": "Edita la Pre-tasca",
    "Edit Post-Task": "Edita la Post-tasca",
    "Add text": "Afegeix text",
    "Add image": "Afegeix imatge",
    "Add audio": "Afegeix àudio",
    "Add video": "Afegeix vídeo",
    "Title": "Títol",
    "Drag to reorder": "Arrossega per reordenar",
    "Are you sure you want to delete this material?": "Segur que vols eliminar aquest material?",
    "Please enter a title.": "Introdueix un títol.",
    "It will be active again shortly.": "S\'activarà de nou en breu.",
    "Thank you for your patience.": "Gràcies per la vostra paciència.",
    "You don\'t have an account?": "Encara no tens un compte?",
    "Register as a new user": "Registra’t com a nou usuari",
    "Register": "Registra\'t",
    "University": "Universitat",
    "Secondary school": "Institut d’educació secundària",
    "Primary school": "Escola primària",
    "Private tutoring": "Classes particulars",
    "Online private tutoring": "Classes particulars en línia",
    "Language school": "Escola de llengües",
    "I am not teaching yet": "Encara no estic ensenyant.",
    "Face to Face": "Presencial",
    "Fully online": "Totalment en línia",
    "Hybrid/Blended": "Híbrid",
    "Task Based Language Teaching": "Ensenyament de Llengües Basat en Tasques (TBLT)",
    "Content and Language Integrate Learning": "Aprenentatge Integrat de Contingut i Llengua (CLIL)",
    "Project-based Learning": "Aprenentatge Basat en Projectes",
    "Traditional Teaching": "Ensenyament tradicional",
    "Language for Specific Purposes": "Llengua per a propòsits específics",
    "Language for Academic Purposes": "Llengua per a finalitats acadèmiques",
    "English as a Medium of Instruction": "L’anglès com a llengua vehicular d’instrucció",
    "Afghanistan": "Afganistan",
    "Albania": "Albània",
    "Algeria": "Algèria",
    "American Samoa": "Samoa Americana",
    "Andorra": "Andorra",
    "Angola": "Angola",
    "Anguilla : \"Anguilla\"": "Anguilla",
    "Antarctica": "Antàrtida",
    "Antigua and Barbuda": "Antigua i Barbuda",
    "Argentina": "Argentina",
    "Armenia": "Armènia",
    "Aruba": "Aruba",
    "Australia": "Austràlia",
    "Austria": "Àustria",
    "Azerbaijan": "Azerbaidjan",
    "Bahamas (the)": "Bahames",
    "Bahrain": "Bahrain",
    "Bangladesh": "Bangladesh",
    "Barbados : \"Barbados\"": "Barbados",
    "Belarus": "Belarús",
    "Belgium": "Bèlgica",
    "Belize": "Belize",
    "Benin": "Benín",
    "Bermuda": "Bermudes",
    "Bhutan": "Bhutan",
    "Bolivia (Plurinational State of) : \"Bolivia (Plurinational State of)\"": "Bolívia (Estat Plurinacional de)",
    "Bonaire, Sint Eustatius and Saba : \"Bonaire": "Bonaire, Sint Eustatius i Saba",
    "Bosnia and Herzegovina": "Bòsnia i Hercegovina",
    "Botswana : \"Botswana\"": "Botswana",
    "Bouvet Island": "Illa Bouvet",
    "Brazil": "Brasil",
    "British Indian Ocean Territory (the) : \"British Indian Ocean Territory (the)\"": "Territori Britànic de l’Oceà Índic",
    "Brunei Darussalam": "Brunei Darussalam",
    "Bulgaria : \"Bulgaria\"": "Bulgària",
    "Burkina Faso : \"Burkina Faso\"": "Burkina Faso",
    "Burundi": "Burundi",
    "Cabo Verde": "Cabo Verde",
    "Cambodia : \"Cambodia\"": "Cambodja",
    "Cameroon : \"Cameroon\"": "Camerun",
    "Canada": "Canadà",
    "Cayman Islands (the) : \"Cayman Islands (the)\"": "les Illes Caiman",
    "Central African Republic (the)": "República Centrafricana",
    "Chad : \"Chad\"": "Xad : \"Xad\"",
    "Chile": "Xile",
    "China": "Xina",
    "Christmas Island : \"Christmas Island\"": "Illa Christmas",
    "Cocos (Keeling) Islands (the)": "Illes Cocos (Keeling)",
    "Colombia : \"Colombia\"": "Colòmbia",
    "Comoros (the)": "Comores",
    "Congo (the Democratic Republic of the)": "República Democràtica del Congo",
    "Congo (the)": "República del Congo",
    "Cook Islands (the)": "les Illes Cook",
    "Costa Rica": "Costa Rica",
    "Croatia": "Croàcia",
    "Cuba : \"Cuba\"": "Cuba",
    "Curaçao": "Curaçao",
    "Cyprus": "Xipre",
    "Czechia": "República Txeca",
    "Côte d\'Ivoire": "Costa d’Ivori",
    "Denmark": "Dinamarca",
    "Djibouti : \"Djibouti\"": "Djibouti",
    "Dominica : \"Dominica\"": "Dominica : \"Dominica\"",
    "Dominican Republic (the) : \"Dominican Republic (the)\"": "la República Dominicana",
    "Ecuador": "Equador",
    "Egypt": "Egipte",
    "El Salvador": "El Salvador",
    "Equatorial Guinea": "Guinea Equatorial",
    "Eritrea": "Eritrea",
    "Estonia": "Estònia",
    "Eswatini : \"Eswatini\"": "Eswatini",
    "Ethiopia : \"Ethiopia\"": "Etiòpia",
    "Falkland Islands (the) [Malvinas]": "Illes Malvines [Falkland]",
    "Faroe Islands (the)": "les Illes Fèroe",
    "Fiji : \"Fiji\"": "Fiji",
    "Finland": "Finlàndia",
    "France": "França",
    "French Guiana": "Guaiana Francesa",
    "French Polynesia : \"French Polynesia\"": "Polinèsia Francesa",
    "French Southern Territories (the)": "els Territoris Francesos del Sud",
    "Gabon": "Gabon",
    "Gambia (the) : \"Gambia (the)\"": "Gàmbia",
    "Georgia": "Geòrgia",
    "Germany": "Alemanya",
    "Ghana": "Ghana",
    "Gibraltar": "Gibraltar",
    "Greece": "Grècia",
    "Greenland": "Groenlàndia",
    "Grenada": "Granada",
    "Guadeloupe": "Guadeloupe",
    "Guam : \"Guam\"": "Guam",
    "Guatemala": "Guatemala",
    "Guernsey : \"Guernsey\"": "Guernsey",
    "Guinea": "Guinea",
    "Guinea-Bissau": "Guinea Bissau",
    "Guyana": "Guyana",
    "Haiti": "Haití",
    "Heard Island and McDonald Islands": "Illa Heard i Illes McDonald",
    "Holy See (the)": "Santa Seu",
    "Honduras : \"Honduras\"": "Hondures",
    "Hong Kong": "Regió Administrativa Especial de Hong Kong",
    "Hungary": "Hongria",
    "Iceland": "Islàndia",
    "India": "Índia",
    "Indonesia": "Indonèsia",
    "Iran (Islamic Republic of)": "Iran (República Islàmica de)",
    "Iraq : \"Iraq\"": "Iraq",
    "Ireland": "Irlanda",
    "Isle of Man": "Illa de Man",
    "Israel": "Israel",
    "Italy": "Itàlia",
    "Jamaica": "Jamaica",
    "Japan": "Japó",
    "Jersey": "Jersey",
    "Jordan": "Jordània",
    "Kazakhstan": "Kazakhstan",
    "Kenya": "Kenya",
    "Kiribati : \"Kiribati\"": "Kiribati",
    "Korea (the Democratic People\'s Republic of)": "República Popular Democràtica de Corea",
    "Korea (the Republic of)": "República de Corea",
    "Kuwait": "Kuwait",
    "Kyrgyzstan": "Kirguizistan",
    "Lao People\'s Democratic Republic (the)": "República Democràtica Popular Lao",
    "Latvia": "Letònia",
    "Lebanon": "Líban",
    "Lesotho": "Lesotho",
    "Liberia": "Libèria",
    "Libya": "Líbia",
    "Liechtenstein": "Liechtenstein",
    "Lithuania": "Lituània",
    "Luxembourg": "Luxemburg",
    "Macao": "Regió Administrativa Especial de Macau de la República Popular de la Xina",
    "Madagascar": "Madagascar",
    "Malawi": "Malawi",
    "Malaysia : \"Malaysia\"": "Malàisia",
    "Maldives : \"Maldives\"": "Maldives: \"Maldives\"",
    "Mali : \"Mali\"": "Mali",
    "Malta": "Malta",
    "Marshall Islands (the)": "les Illes Marshall",
    "Martinique": "Martinica",
    "Mauritania": "Mauritània",
    "Mauritius": "Maurici",
    "Mayotte": "Mayotte",
    "Mexico": "Mèxic",
    "Micronesia (Federated States of) : \"Micronesia (Federated States of)\"": "Estats Federats de Micronèsia",
    "Moldova (the Republic of)": "República de Moldàvia",
    "Monaco": "Mònaco",
    "Mongolia : \"Mongolia\"": "Mongòlia",
    "Montenegro": "Montenegro",
    "Montserrat": "Montserrat",
    "Morocco": "Marroc",
    "Mozambique": "Moçambic",
    "Myanmar": "Myanmar",
    "Namibia": "Namíbia",
    "Nauru": "Nauru",
    "Nepal": "Nepal",
    "Netherlands (the)": "Països Baixos",
    "New Caledonia": "Nova Caledònia",
    "New Zealand": "Nova Zelanda",
    "Nicaragua": "Nicaragua",
    "Niger (the)": "el Níger",
    "Nigeria": "Nigèria",
    "Niue : \"Niue\"": "Niue",
    "Norfolk Island": "Illa Norfolk",
    "Northern Mariana Islands (the)": "les Illes Marianes del Nord",
    "Norway": "Noruega",
    "Oman : \"Oman\"": "Oman",
    "Pakistan : \"Pakistan\"": "Pakistan",
    "Palau": "Palau",
    "Palestine, State of": "Estat de Palestina",
    "Panama": "Panamà",
    "Papua New Guinea : \"Papua New Guinea\"": "Papua Nova Guinea",
    "Paraguay : \"Paraguay\"": "Paraguai",
    "Peru : \"Peru\"": "Perú",
    "Philippines (the)": "les Filipines",
    "Pitcairn : \"Pitcairn\"": "Illes Pitcairn",
    "Poland": "Polònia",
    "Portugal : \"Portugal\"": "Portugal",
    "Puerto Rico": "Puerto Rico",
    "Qatar": "Qatar",
    "Republic of North Macedonia": "Macedònia del Nord",
    "Romania": "Romania",
    "Russian Federation (the) : \"Russian Federation (the)\"": "la Federació Russa",
    "Rwanda": "Ruanda",
    "Réunion": "Reunió",
    "Saint Barthélemy : \"Saint Barthélemy\"": "Sant Bartomeu",
    "Saint Helena, Ascension and Tristan da Cunha : \"Saint Helena": "Santa Helena",
    "Saint Kitts and Nevis": "Saint Kitts i Nevis",
    "Saint Lucia": "Santa Llúcia",
    "Saint Martin (French part)": "Sant Martí (part francesa)",
    "Saint Pierre and Miquelon": "Saint-Pierre-et-Miquelon",
    "Saint Vincent and the Grenadines : \"Saint Vincent and the Grenadines\"": "Saint Vicent i les Grenadines",
    "Samoa": "Samoa",
    "San Marino": "San Marino",
    "Sao Tome and Principe": "São Tomé i Príncipe",
    "Saudi Arabia : \"Saudi Arabia\"": "Aràbia Saudita",
    "Senegal": "Senegal",
    "Serbia": "Sèrbia",
    "Seychelles": "Seychelles",
    "Sierra Leone : \"Sierra Leone\"": "Serra Lleona",
    "Singapore": "Singapur",
    "Sint Maarten (Dutch part)": "Sint Maarten (part neerlandesa)",
    "Slovakia : \"Slovakia\"": "Eslovàquia",
    "Slovenia : \"Slovenia\"": "Eslovènia",
    "Solomon Islands": "Illes Salomó",
    "Somalia": "Somàlia",
    "South Africa : \"South Africa\"": "Sud-àfrica",
    "South Georgia and the South Sandwich Islands : \"South Georgia and the South Sandwich Islands\"": "Illes Geòrgia del Sud i Sandwich del Sud",
    "South Sudan": "Sudan del Sud",
    "Spain": "Espanya",
    "Sri Lanka": "Sri Lanka",
    "Sudan (the)": "el Sudan",
    "Suriname : \"Suriname\"": "Surinam",
    "Svalbard and Jan Mayen": "Svalbard i Jan Mayen",
    "Sweden": "Suècia",
    "Switzerland": "Suïssa",
    "Syrian Arab Republic : \"Syrian Arab Republic\"": "República Àrab Síria",
    "Taiwan": "Taiwan (Província de la Xina)",
    "Tajikistan": "Tadjikistan",
    "Tanzania, United Republic of : \"Tanzania": "Tanzània, República Unida de",
    "Thailand : \"Thailand\"": "Tailàndia",
    "Timor-Leste": "Timor-Leste",
    "Togo : \"Togo\"": "Togo",
    "Tokelau": "Tokelau",
    "Tonga": "Tonga",
    "Trinidad and Tobago": "Trinitat i Tobago",
    "Tunisia": "Tunísia",
    "Turkey": "Turquia",
    "Turkmenistan : \"Turkmenistan\"": "Turkmenistan",
    "Turks and Caicos Islands (the)": "les Illes Turks i Caicos",
    "Tuvalu": "Tuvalu",
    "Uganda": "Uganda",
    "Ukraine": "Ucraïna",
    "United Arab Emirates (the)": "Emirats Àrabs Units",
    "United Kingdom of Great Britain and Northern Ireland (the)": "Regne Unit de Gran Bretanya i Irlanda del Nord",
    "United States Minor Outlying Islands (the)": "Illes Perifèriques Menors dels Estats Units d’Amèrica",
    "United States of America (the)": "Estats Units d’Amèrica",
    "Uruguay": "Uruguai",
    "Uzbekistan": "Uzbekistan",
    "Vanuatu": "Vanuatu",
    "Venezuela (Bolivarian Republic of)": "República Bolivariana de Veneçuela",
    "Viet Nam : \"Viet Nam\"": "Vietnam",
    "Virgin Islands (British) : \"Virgin Islands (British)\"": "Illes Verges Britàniques",
    "Virgin Islands (U.S.)": "Illes Verges dels Estats Units d’Amèrica",
    "Wallis and Futuna": "Wallis i Futuna",
    "Western Sahara": "Sàhara Occidental",
    "Yemen": "Iemen",
    "Zambia": "Zàmbia",
    "Zimbabwe : \"Zimbabwe\"": "Zimbabwe",
    "Åland Islands": "Illes Åland",
    "No organization selected.": "No s\'ha seleccionat cap organització.",
    "Users groups": "Grups d’usuaris",
    "New group": "Nou grup",
    "Id": "Id",
    "Name": "Nom",
    "Users": "Usuaris",
    "Actions": "Accions",
    "1 user": "1 usuari",
    "users": "usuaris",
    "No users assigned": "No s\'ha assignat cap usuari",
    "Edit group": "Edita el grup",
    "Delete group": "Suprimeix el grup",
    "Enter a name": "Introdueix un nom",
    "Description": "Descripció",
    "Save": "Desa",
    "You are about to delete organization content <strong>{{name}}</strong>. \'This action cannot be undone. Are you sure you want to proceed?": "Estàs a punt d\'esborrar el contingut de l’organització <strong>{{name}}</strong>. Aquesta acció no es pot desfer. Estàs segur que vols continuar?",
    "Yes": "Sí",
    "No": "No",
    "Add new group": "Afegeix un grup nou",
    "Conditions of Use": "Condicions d’ús",
    "Introduction": "Introducció",
    "The taskGen Project is a three-year research initiative supported by grant PID2020-119009RB-I00 from the Spanish Ministry of Science and Innovation (MCIN) and the National Research Agency (AEI) [Reference: 10.13039/501100011033]. At the University of Barcelona, we have developed the taskGen web-based tool for the automated design of second/foreign language communicative tasks. Participants engaging in the pilot evaluation through the taskGen platform are required to read and agree to the terms outlined below.": "El projecte taskGen és una iniciativa de recerca de tres anys que compta amb el suport de la subvenció PID2020-119009RB-I00 del Ministeri de Ciència i Innovació del Govern d’Espanya (MCIN) i de l’Agència Estatal de Recerca (AEI) [Referència: 10.13039/501100011033]. A la Universitat de Barcelona, hem desenvolupat l’eina web taskGen per al disseny automatitzat de tasques comunicatives en segona llengua o llengua estrangera. Es requereix que les persones participants en l’avaluació pilot a través de la plataforma taskGen llegeixin i acceptin els termes que es detallen a continuació.",
    "Consent": "Consentiment",
    "Participants engaging in this pilot evaluation of the taskGen tool implicitly agree to these terms upon logging into the platform.": "Els participants que prenen part en aquesta avaluació pilot de l’eina taskGen accepten implícitament aquests termes en iniciar sessió a la plataforma.",
    "Aim of this research project": "Objectiu d’aquest projecte de recerca",
    "The aim is to develop a web-based tool that will assist teachers in the design of second and foreign language tasks. The goal is for the tool to help teacher create, clone, share, download/upload onto teaching platforms, and to analyze texts for the automatic detection of linguistic features. Additionally, the tool can be used for training as it contains aids with information about task design.": "L’objectiu és desenvolupar una eina web que assisteixi els mestres en el disseny de tasques de segona llengua i llengua estrangera. Aquesta eina ha de facilitar als mestres la creació, clonació, compartició, descàrrega i pujada de tasques a plataformes d’ensenyament, així com l’anàlisi de textos per a la detecció automàtica de característiques lingüístiques. A més, l’eina també es pot utilitzar per a la formació, ja que inclou recursos amb informació sobre el disseny de tasques.",
    "Kind participation": "Participació cordial",
    "taskGen users can design, organize, store, and share tasks with other users within the taskGen system. Participation may be stopped at any point. Participants can delete their accounts and leave the system.": "Els usuaris de taskGen podran dissenyar, organitzar, emmagatzemar i compartir tasques amb altres usuaris dins del sistema taskGen. La participació es pot interrompre en qualsevol moment. Els participants poden eliminar els seus comptes i abandonar el sistema.",
    "Types of data to be processed": "Tipus de dades a tractar",
    "During the implementation of the pilot, the tool will process (retrieve, store, produce, relate, analyze and use automatically):": "Durant la implementació del pilot, l\'eina processarà (recuperarà, emmagatzemarà, produirà, relacionarà, analitzarà i utilitzarà automàticament):",
    "From your profile data: educational context, teaching modality, teaching approach, country, years of experience. No information related to your identity will be processed, analysed or shared.": "A partir de les dades del teu perfil: context educatiu, modalitat d’ensenyament, enfocament pedagògic, país, anys d’experiència. No es processarà, analitzarà ni compartirà cap informació relacionada amb la teva identitat.",
    "System use data: timestamps of platform interaction, mouse-click tracking, text length, choice of pre-task and post-task types, choice of text editing and analysis tools, design options, and use of aids.": "Dades d\'ús del sistema: marcadors temporals de la interacció amb la plataforma, seguiment dels clics del ratolí, longitud del text, selecció de tipus de pre-tasques i post-tasques, tria d\'eines d\'edició i anàlisi de text, opcions de disseny i ús de suports.",
    "Database Security": "Seguretat de la base de dades",
    "Collected data will be securely stored, with access limited to authorized personnel only. Stringent security measures will be employed to protect confidentiality.": "Les dades recollides s’emmagatzemaran de manera segura, amb accés limitat exclusivament al personal autoritzat. Es prendran mesures de seguretat estrictes per protegir-ne la confidencialitat.",
    "Data retrieval and treatment": "Recuperació i tractament de dades",
    "Standard and secure data analytics tools will be used to retrieve and analyze the collected data exclusively for research purposes.": "S\'utilitzaran eines d\'anàlisi de dades estàndard i segures per recuperar i analitzar les dades recollides exclusivament amb finalitats de recerca.",
    "Objectives and legal basis for the processing and treatment of data": "Objectius i base legal per al processament i el tractament de dades",
    "The processing and treatment of the data follows the principles of the data protection law (GDPR) 2016-679 of the European Union as well as the Catalan Agency of Data Protection.": "El processament i el tractament de les dades segueixen els principis del Reglament general de protecció de dades (RGPD) 2016/679 de la Unió Europea, així com els de l’Autoritat Catalana de Protecció de Dades.",
    "Data will be stored until four years after the end of the project. The treatment of personal data is carried out at/by the General Secretary of Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. The email address is secretaria.general@ub.edu. You can revoke your consent at any point by contacting the email address above.": "Les dades es conservaran fins a quatre anys després de la finalització del projecte. El tractament de dades personals es duu a terme a la Secretaria General de la Universitat de Barcelona, Gran Via de les Corts Catalanes, 585, 08007 Barcelona. L\'adreça de correu electrònic és secretaria.general@ub.edu. Podeu revocar el vostre consentiment en qualsevol moment posant-vos en contacte amb l’adreça de correu electrònic esmentada anteriorment.",
    "Research Purposes and confidentiality": "Finalitats de la recerca i confidencialitat",
    "The collected data will be used solely for research purposes, enhancing understanding, improving user experience, and informing project development. The results of the project will appear in academic publications and organizations (e.g. Ministry of Education, statistical services, etc.) or in the media with no reference to any data related to participants’ personal information, hence ensuring security, privacy and anonymity. No commercial utilization or third-party sharing will occur.": "Les dades recollides s\'utilitzaran exclusivament amb finalitats de recerca, per millorar la comprensió, l’experiència de l’usuari i per informar sobre el desenvolupament del projecte. Els resultats del projecte es presentaran en publicacions acadèmiques i davant d’organitzacions (per exemple, el Ministeri d’Educació, serveis estadístics, etc.) o en mitjans de comunicació, sense cap referència a dades relacionades amb la informació personal dels participants, garantint així la seguretat, la privacitat i l’anonimat. No es farà cap ús comercial ni es compartiran amb tercers.",
    "Ethical Compliance": "Compliment ètic",
    "The data collection process strictly adheres to ethical standards as set by the University of Barcelona, ensuring responsible handling of information throughout collection, storage, and analysis.": "El procés de recopilació de dades respecta estrictament els estàndards ètics establerts per la Universitat de Barcelona, garantint una gestió responsable de la informació durant la recopilació, l’emmagatzematge i l’anàlisi.",
    "Modification of Terms": "Modificació de termes",
    "Terms may be modified during the project, and participants will be notified of any changes.": "Les condicions poden modificar-se durant el projecte, i s’informarà els participants de qualsevol canvi.",
    "By utilizing the platform, participants acknowledge their understanding and agreement with these terms. Failure to comply may result in access termination.": "En utilitzar la plataforma, els participants reconeixen que entenen i accepten aquests termes. L\'incompliment pot comportar la finalització de l\'accés.",
    "If you consider that your rights have not been adequately addressed, you can notify the UB Data Protection Delegate: protecciodedades@ub.edu or Travessera de les Corts, 131-159, Pabellón Rosa, 08028 Barcelona.": "Si considereu que els vostres drets no han estat degudament atesos, podeu notificar-ho al Delegat de Protecció de Dades de la UB a l’adreça electrònica protecciodedades@ub.edu o presencialment a Travessera de les Corts, 131-159, Pavelló Rosa, 08028 Barcelona.",
    "Likewise, you have the right to file a claim with the Catalan Data Protection Authority.": "Igualment, teniu dret a presentar una reclamació davant l’Autoritat Catalana de Protecció de Dades.",
    "If you have any questions, you can contact the taskGen team at<br />taskgenproject@gmail.com": "Si tens cap pregunta, pots contactar amb l’equip de taskGen a l’adreça taskgenproject@gmail.com.",
    "By accepting these terms and conditions, I hereby certify that I have permission to use and release the materials included in my task designs. I am responsible for the materials that I will be sharing with other users within taskGen.": "En acceptar aquests termes i condicions, certifico que tinc permís per utilitzar i divulgar els materials inclosos en els meus dissenys de tasques. Sóc responsable dels materials que compartiré amb altres usuaris dins de taskGen.",
    "The taskGen team<br />University of Barcelona": "L'equip de taskGen<br />Universitat de Barcelona",
    "Data treatment": "Tractament de dades",
    "Update profile": "Actualitza el perfil",
    "Profile": "Perfil",
    "Logout your taskGen session": "Tanca la teva sessió de taskGen",
    "Logout": "Tanca la sessió",
    "Check your inbox and follow the instructions to finish your registration.": "Revisa la teva safata d’entrada i segueix les instruccions per completar el registre.",
    "There was a problem with the registration. It is possible that a user with the same Email is already registered. Please try again later or write to us at info@taskgen.eu.": "Hi ha hagut un problema amb el registre. És possible que ja hi hagi un usuari registrat amb la mateixa adreça electrònica. Torna-ho a intentar més tard o escriu-nos a info@taskgen.eu.",
    "Write your mail address and we\\\'ll send you an email with instructions to finish your registration.": "Escriu la teva adreça electrònica i t’enviarem un missatge amb les instruccions per completar el registre.",
    "Email Address": "Adreça electrònica",
    "By clicking this box, I state that I have read and understood the": "En fer clic en aquesta casella, afirmo que he llegit i entès els termes i condicions",
    "Loading...": "S\'està carregant...",
    "A new password has been sent to your inbox. You can change your password in your profile once you log in.": "S’ha enviat una nova contrasenya a la teva safata d’entrada. Pots canviar-la al teu perfil un cop hagis iniciat sessió.",
    "There was a problem resetting your password. Please try again later or write to us at info@taskgen.eu.": "S\'ha produït un problema en restablir la contrasenya. Torna-ho a intentar més tard o escriu-nos a info@taskgen.eu.",
    "User or password are not vali": "El nom d’usuari o la contrasenya no són vàlids.",
    "Reset your password": "Restableix la contrasenya",
    "You don\'t remember your password?": "Has oblidat la contrasenya?",
    "Reset it": "Torna-ho a iniciar",
    "Login": "Inici de sessió",
    "We would like to kindly ask you complete you user profile. You will do this only once and you can modify your profile at any point.": "Us demanem amablement que completeu el vostre perfil d’usuari. Només caldrà fer-ho una vegada i podreu modificar-lo en qualsevol moment.",
    "Please, tell us where do you usually teach.": "Si us plau, indiqueu-nos on ensenyeu habitualment.",
    "Please, tell us how do you typically teach.": "Si us plau, explica’ns com acostumes a ensenyar.",
    "Please, tell us your general teaching framework.": "Si us plau, explica'ns el teu marc general d'ensenyament.",
    "Please, select your country.": "Si us plau, selecciona el teu país.",
    "Select your country...": "Selecciona el teu país...",
    "Please complete your profile. Missing fields:": "Si us plau, completa el teu perfil. Camps pendents:",
    "name": "nom",
    "privacy policy": "política de privacitat",
    "teaching location": "lloc d'ensenyament",
    "teaching model": "model d'ensenyament",
    "teaching framework": "marc d'ensenyament",
    "country": "país",
    "region": "regió",
    "teaching years": "anys d'experiència docent",
    "Where do you usually teach?": "On ensenyes habitualment?",
    "How do you typically teach?": "Com ensenyes normalment?",
    "What's your general teaching framework?": "Quin és el teu marc general d'ensenyament?",
    "Interface language": "Idioma de la interfície",
    "First name(s)": "Nom(s) de pila",
    "Family name(s)": "Cognom(s)",
    "Other...": "Altres…",
    "Special Needs": "Necessitats específiques",
    "Have you ever trained using TBLT?": "Has fet mai formació utilitzant l’enfocament basat en tasques?",
    "Region or State": "Regió o estat",
    "How many years of teaching experience do you have?": "Quants anys d’experiència tens com a docent de llengües?",
    "Tell us for how long you have been teaching in TLBT": "Digues-nos durant quant de temps has estat ensenyant amb l’enfocament TBLT.",
    "Edit profile": "Edita el perfil",
    "Close window/tab": "Tanca la finestra o pestanya",
    "Shared with students": "Compartida amb l’alumnat",
    "Shared with teachers": "Compartit amb el professorat",
    "Title": "Títol",
    "Authorship": "Autoria",
    "Student\'s proficiency level": "Nivell de competència lingüística de l’estudiant",
    "Aims": "Objectius",
    "Pre-Task": "Pre-tasca",
    "There are no pre-tasks defined": "No hi ha definida cap pre-tasca",
    "Main Tasks": "Tasques principals",
    "There are no tasks": "No hi ha cap tasca disponible.",
    "Post-Task": "Post-tasca",
    "There are no post-tasks": "No hi ha post-tasques.",
    "Close": "Tanca",
    "Aim and instructions": "Objectiu i instruccions",
    "Last updated": "Darrera actualització",
    "Shared by user": "Comparteix amb l’usuari",
    "Shared by group": "Compartit pel grup",
    "Duplicate": "Duplicat",
    "Sharing link copied to your clipboard.": "Enllaç per compartir copiat al porta-retalls.",
    "Edit": "Edita",
    "Share": "Comparteix",
    "Share link": "Comparteix l’enllaç",
    "Move Up": "Mou cap amunt",
    "Move Down": "Desplaça’t cap avall",
    "Delete": "Suprimeix",
    "Share task": "Compartir la tasca",
    "Share with users": "Comparteix amb els {usuari}",
    "Shared with someone at": "Compartit amb algú a",
    "Search users...": "Cerca d’usuaris...",
    "Select the users with whom you want to <strong>share the task</strong>:": "Selecciona els usuaris amb qui vols <strong>compartir la tasca</strong>:",
    "Task is shared with the following users:": "La tasca s’ha compartit amb els usuaris següents:",
    "Share with groups": "Comparteix amb grups",
    "Select the groups you want to <strong>share the task</strong>:": "Selecciona els grups amb què vols <strong>compartir la tasca</strong>:",
    "Task is shared with the following groups:": "La tasca es comparteix amb els grups següents:",
    "Cancel": "Cancel·la",
    "Add formatting rule": "Afegeix regla de format",
    "Feminine": "Femení",
    "Masculine": "Masculí",
    "Common": "Comú",
    "Invariable": "Invariable",
    "Articles": "Articles",
    "Demonstrative": "Demostratiu",
    "Possessive": "Possessiu",
    "Indefinite": "Indefinit",
    "Interrogative": "Interrogatiu",
    "Relative": "Relatiu",
    "Numeral": "Numeral",
    "Exclamatory": "Exclamatiu",
    "Personal Pronouns": "Pronoms personals",
    "Wh-determiner": "Determinant interrogatiu",
    "Subordinating Conjunctions": "Conjuncions subordinants",
    "Neuter": "Neutre",
    "Animate": "Animat",
    "Inanimate": "Inanimat",
    "Singular": "Singular",
    "Plural": "Plural",
    "Nominative": "Nominatiu",
    "Genitive": "Genitiu",
    "Accusative": "Acusatiu",
    "Dative": "Datiu",
    "Instrumental": "Instrumental",
    "Locative": "Locatiu",
    "Cardinal": "Cardinal",
    "Positive": "Positiu",
    "Short form": "Forma curta",
    "Imperfective": "Imperfectiu",
    "Perfective": "Perfectiu",
    "Indicative": "Indicatiu",
    "Conditional": "Condicional",
    "Finite": "Finit",
    "Infinitive": "Infinitiu",
    "Converb": "Converb",
    "Participle": "Participi",
    "Middle": "Mitjà",
    "1st person": "1a persona",
    "2nd person": "2a persona",
    "3rd person": "3a persona",
    "Proper nouns": "Noms propis",
    "All proper nouns": "Tots els noms propis",
    "Numerals": "Numerals",
    "All numerals": "Tots els numerals",
    "Particles": "Partícules",
    "Aspect": "Aspecte",
    "Mood": "Mode",
    "VerbForm": "Forma verbal",
    "Voice": "Veu",
    "Animacy": "Animacitat",
    "Case": "Cas",
    "Gender": "Gènere",
    "Degree": "Grau",
    "Person": "Persona",
    "Form": "Forma",
    "Tense (morphological)": "Temps (morfològic)",
    "Interrogative/Relative": "Interrogatiu/Relatiu",
    "Personal": "Personal",
    "Past": "Passat",
    "Present": "Present",
    "Future": "Futur",
    "Nouns": "Substantius",
    "All nouns": "Tots els substantius",
    "Adjectives": "Adjectius",
    "All adjectives": "Tots els adjectius",
    "Adverbs": "Adverbis",
    "All adverbs": "Tots els adverbis",
    "Verbs": "Verbs",
    "All verbs": "Tots els verbs",
    "Prepositions": "Preposicions",
    "Determiners": "Determinants",
    "All determiners": "Tots els determinants",
    "Pronouns": "Pronoms",
    "All pronouns": "Tots els pronoms",
    "Contractions": "Contraccions",
    "Coordinating Conjunctions": "Conjuncions coordinants",
    "Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.": "Ho sentim! El resultat de l'anàlisi del text és buit o s'han trobat errors. Revisa i canvia el text i torna-ho a provar.",
    "My design": "El meu disseny",
    "Teacher version": "Versió per al professorat",
    "Preview": "Previsualització",
    "Download SCORM": "Descarrega el paquet SCORM",
    "Download HTML": "Descarrega l’HTML",
    "Student version": "Versió per a estudiants",
    "Sessions": "Sessions",
    "Session name": "Nom de la sessió",
    "Update": "Actualització",
    "Add session": "Afegeix una sessió",
    "Type": "Tipus",
    "Clone pre-task": "Clonació de la pre-tasca",
    "Edit pre-task": "Edita la pre-tasca",
    "Delete pre-task": "Suprimeix la pre-tasca",
    "Are you sure you want to delete the pre-task <strong>": "Estàs segur que vols suprimir la pre-tasca <strong>",
    "</strong>? This action cannot be undone.": "Aquesta acció no es pot desfer.",
    "Are you sure you want to delete the post-task <strong>": "Esteu segur que voleu suprimir la post-tasca <strong>",
    "Pos-Task has been clonned as a Pre-Task.": "La post-tasca s\'ha clonat com a pre-tasca.",
    "Write the name of the task": "Escriu el nom de la tasca",
    "Task metadata": "Metadades de la tasca",
    "Author(s)": "Autor(s)",
    "Original authorship": "Autoria original",
    "Task language": "Idioma de la tasca",
    "Catalan": "Català",
    "English": "Anglès",
    "Spanish": "Castellà",
    "Russian": "Rus",
    "Russian analyzer not available yet":"Analitzador en rus no disponible encara",
    "The Russian text analyzer is not available yet, but it will be soon. We are working on it!":"L'analitzador de text en rus no està disponible encara, però ho estarà aviat. Estem treballant-hi!",
    "Language in which the task is designed": "Idioma en què està dissenyada la tasca",
    "General aim of the task": "Objectiu general de la tasca",
    "Specific aim of the task": "Objectiu específic de la tasca",
    "Other (please specify)": "Altres (si us plau, especifiqueu-ho)",
    "This information will be especially useful if you intend to share the task.": "Aquesta informació serà especialment útil si tens la intenció de compartir la tasca amb altres docents o estudiants.",
    "New Pre-Task": "Nova pre-tasca",
    "Use a text for reading comprehension and to highlight language input": "Utilitza un text per a la comprensió lectora i per destacar l’entrada de llengua.",
    "Text": "Text",
    "Audios are great sources of input.": "Els àudios són una font valuosa d’input lingüístic.",
    "Audio": "Àudio",
    "Videos are excellent sources of ‘multimodal’ input. They present together images, text, and audio in meaningful ways that facilitate second language learning.": "Els vídeos són excel·lents fonts d’entrada multimodal. Presenten imatges, text i àudio de manera significativa, cosa que facilita l’aprenentatge d’una segona llengua.",
    "Video": "Vídeo",
    "Reading comprehension dialogues provide an opportunity for both reading and speaking practice.": "Els diàlegs de comprensió lectora ofereixen una oportunitat tant per a la lectura com per a la producció oral.",
    "Written dialogue": "Diàleg escrit",
    "Photos provide excellent opportunities to generate communication and interaction.": "Les fotografies ofereixen excel·lents oportunitats per generar llengua i interacció.",
    "Photo": "Fotografia",
    "Video and audio transcripts provide exposure to rich and meaningful input that can be used in several ways.": "Les transcripcions de vídeo i àudio ofereixen una exposició a contingut ric i significatiu que es pot utilitzar de diverses maneres dins del cicle de la tasca.",
    "Speech transcript": "Transcripció del discurs",
    "Interaction activities can be used in preparation for the main task.": "Les activitats d’interacció es poden utilitzar com a pre-tasca per preparar la tasca principal.",
    "Interaction activity": "Tasca d’interacció",
    "Game": "Joc/tasca lúdica",
    "Warm-ups at the beginning of a lesson may serve as a smooth introduction to the topic/content of the lesson, as an opportunity for learners to progressively switch to the second or foreign language, and as a way to get into the language lesson mood.": "Les activitats d’escalfament al començament d’una lliçó poden servir com una introducció suau al tema o contingut de la lliçó, com una oportunitat perquè els alumnes facin una transició progressiva cap a la segona llengua o llengua estrangera, i com una manera d’entrar en la disposició adequada per a la classe de llengua.",
    "Warm-up": "Activitat d’escalfament",
    "Main Task": "Tasca principal",
    "New Main Task": "Nova tasca principal",
    "New Post-Task": "Nova post-tasca",
    "Task repetition is known to have a positive impact on all aspects of production and learning.": "Se sap que la repetició de tasques té un impacte positiu en tots els aspectes de la producció i l’aprenentatge.",
    "Task repetition": "Repetició de la tasca",
    "Explicit explanations can help solve or consolidate language issues that came up during task performance.": "Les explicacions explícites poden ajudar a resoldre o consolidar problemes de llengua que han sorgit durant la realització de la tasca.",
    "Explicit explanation": "Explicació explícita",
    "Written to Oral / Oral to Written": "De l’escrit a l’oral / De l’oral a l’escrit",
    "Task model and exercises": "Model de tasques i activitats",
    "Exercises": "Tasques",
    "Shared task": "Tasca compartida",
    "The task <strong>": "La tasca <strong>",
    "</strong> is already shared with you.": "Ja està compartit amb tu.",
    "Do you want to add the task <strong>\'": "Vols afegir la tasca <strong>\'",
    "</strong> to the collection of tasks shared with you?": "a la col·lecció de tasques que s’han compartit amb tu?",
    "If you accept this shared task, you will be allowed to clone it to create your own version of the task.": "Si acceptes aquesta tasca compartida, podràs clonar-la per crear-ne la teva pròpia versió.",
    "Accept": "Accepta",
    "Reject": "Rebutja",
    "Delete task": "Suprimeix la tasca",
    "You are about to delete the task <strong>": "Estàs a punt d\'eliminar la tasca <strong>",
    "</strong>. This action cannot be undone.": "Aquesta acció no es pot desfer.",
    "(copy)":"(còpia)",
    "- Select a proficiency level -":"- Selecciona un nivell de competència -",
    "- Select a prompt -":"- Selecciona una consigna -",
    "- Select a role -":"- Selecciona un rol -",
    "- Select a session -":"- Selecciona una sessió -",
    "- Select a tag -":"- Selecciona una etiqueta -",
    "- Select an aim -":"- Selecciona un objectiu -",
    "- Select an organization -":"- Selecciona una organització -",
    "@":"@",
    "A learner with the 'Student' role has been added to this group correctly":"S'ha afegit correctament un estudiant amb el rol 'Estudiant' a aquest grup",
    "A new password has been sent to your email address":"S'ha enviat una contrasenya nova a la teva adreça de correu electrònic",
    "A new version of the activity @name has been created":"S'ha creat una versió nova de l'activitat @name",
    "A person in this role...":"Una persona en aquest rol...",
    "A teacher with the 'Teacher' role has been added to this group correctly":"S'ha afegit correctament un professor amb el rol 'Professor' a aquest grup",
    "A user with email @mail already exists":"Ja existeix un usuari amb el correu electrònic @mail",
    "About":"Quant a",
    "About this site":"Quant a aquest lloc",
    "Access denied":"Accés denegat",
    "Account":"Compte",
    "Action":"Acció",
    "Active":"Actiu",
    "Activities":"Activitats",
    "Activity":"Activitat",
    "Activity <em>@name</em> updated":"Activitat <em>@name</em> actualitzada",
    "Activity @name has been deleted correctly":"L'activitat @name s'ha eliminat correctament",
    "Activity @name has been updated correctly":"L'activitat @name s'ha actualitzat correctament",
    "Activity created":"Activitat creada",
    "Activity created correctly":"Activitat creada correctament",
    "Activity deleted":"Activitat eliminada",
    "Activity name":"Nom de l'activitat",
    "Activity title":"Títol de l'activitat",
    "Activity type":"Tipus d'activitat",
    "Activity updated":"Activitat actualitzada",
    "Add":"Afegeix",
    "Add a new activity":"Afegeix una activitat nova",
    "Add a new group":"Afegeix un grup nou",
    "Add a new learner":"Afegeix un estudiant nou",
    "Add a new organization":"Afegeix una organització nova",
    "Add a new prompt":"Afegeix una consigna nova",
    "Add a new role":"Afegeix un rol nou",
    "Add a new tag":"Afegeix una etiqueta nova",
    "Add a new teacher":"Afegeix un professor nou",
    "Add a new user":"Afegeix un usuari nou",
    "Add activity":"Afegeix activitat",
    "Add group":"Afegeix grup",
    "Add learner":"Afegeix estudiant",
    "Add learners":"Afegeix estudiants",
    "Add new activity":"Afegeix activitat nova",
    "Add new organization":"Afegeix organització nova",
    "Add new prompt":"Afegeix consigna nova",
    "Add new role":"Afegeix rol nou",
    "Add new tag":"Afegeix etiqueta nova",
    "Add new user":"Afegeix usuari nou",
    "Add organization":"Afegeix organització",
    "Add prompt":"Afegeix consigna",
    "Add role":"Afegeix rol",
    "Add tag":"Afegeix etiqueta",
    "Add teacher":"Afegeix professor",
    "Add teachers":"Afegeix professors",
    "Add to group":"Afegeix al grup",
    "Add user":"Afegeix usuari",
    "Added by":"Afegit per",
    "Added on":"Afegit el",
    "Admin":"Administrador",
    "Administration":"Administració",
    "Administrator":"Administrador",
    "Aim":"Objectiu",
    "All":"Tot",
    "All activities":"Totes les activitats",
    "All groups":"Tots els grups",
    "All organizations":"Totes les organitzacions",
    "All prompts":"Totes les consignes",
    "All roles":"Tots els rols",
    "All sessions":"Totes les sessions",
    "All tags":"Totes les etiquetes",
    "All users":"Tots els usuaris",
    "An error has occurred":"S'ha produït un error",
    "An error occurred and processing did not complete":"S'ha produït un error i el processament no s'ha completat",
    "An error occurred during the creation of the activity":"S'ha produït un error durant la creació de l'activitat",
    "An error occurred during the update of the activity":"S'ha produït un error durant l'actualització de l'activitat",
    "An error occurred while creating the group":"S'ha produït un error en crear el grup",
    "An error occurred while creating the organization":"S'ha produït un error en crear l'organització",
    "An error occurred while creating the prompt":"S'ha produït un error en crear la consigna",
    "An error occurred while creating the role":"S'ha produït un error en crear el rol",
    "An error occurred while creating the tag":"S'ha produït un error en crear l'etiqueta",
    "An error occurred while creating the user":"S'ha produït un error en crear l'usuari",
    "An error occurred while deleting the activity":"S'ha produït un error en eliminar l'activitat",
    "An error occurred while deleting the group":"S'ha produït un error en eliminar el grup",
    "An error occurred while deleting the organization":"S'ha produït un error en eliminar l'organització",
    "An error occurred while deleting the prompt":"S'ha produït un error en eliminar la consigna",
    "An error occurred while deleting the role":"S'ha produït un error en eliminar el rol",
    "An error occurred while deleting the tag":"S'ha produït un error en eliminar l'etiqueta",
    "An error occurred while deleting the user":"S'ha produït un error en eliminar l'usuari",
    "An error occurred while updating the group":"S'ha produït un error en actualitzar el grup",
    "An error occurred while updating the organization":"S'ha produït un error en actualitzar l'organització",
    "An error occurred while updating the prompt":"S'ha produït un error en actualitzar la consigna",
    "An error occurred while updating the role":"S'ha produït un error en actualitzar el rol",
    "An error occurred while updating the tag":"S'ha produït un error en actualitzar l'etiqueta",
    "An error occurred while updating the user":"S'ha produït un error en actualitzar l'usuari",
    "Assign":"Assigna",
    "Assign activities":"Assigna activitats",
    "Assign learners":"Assigna estudiants",
    "Assign teachers":"Assigna professors",
    "Assigned":"Assignat",
    "Assigned activities":"Activitats assignades",
    "Assigned groups":"Grups assignats",
    "Assigned to":"Assignat a",
    "Attempt":"Intent",
    "Attempts":"Intents",
    "Author":"Autor",
    "Available":"Disponible",
    "Back":"Enrere",
    "Back to list":"Torna a la llista",
    "Body":"Cos",
    "Browse":"Navega",
    "By":"Per",
    "Categories":"Categories",
    "Category":"Categoria",
    "Change":"Canvia",
    "Change password":"Canvia la contrasenya",
    "Changed":"Canviat",
    "Class":"Classe",
    "Click here":"Fes clic aquí",
    "Code":"Codi",
    "Collapse":"Replega",
    "Comment":"Comentari",
    "Comments":"Comentaris",
    "Complete":"Completa",
    "Completed":"Completat",
    "Confirm":"Confirma",
    "Confirm deletion":"Confirma l'eliminació",
    "Confirm password":"Confirma la contrasenya",
    "Contact":"Contacte",
    "Content":"Contingut",
    "Continue":"Continua",
    "Copy":"Copia",
    "Course":"Curs",
    "Courses":"Cursos",
    "Create":"Crea",
    "Create a new account":"Crea un compte nou",
    "Create account":"Crea un compte",
    "Create activity":"Crea activitat",
    "Create group":"Crea grup",
    "Create new":"Crea nou",
    "Create new activity":"Crea activitat nova",
    "Create new group":"Crea grup nou",
    "Create new organization":"Crea organització nova",
    "Create new prompt":"Crea consigna nova",
    "Create new role":"Crea rol nou",
    "Create new tag":"Crea etiqueta nova",
    "Create organization":"Crea organització",
    "Create prompt":"Crea consigna",
    "Create role":"Crea rol",
    "Create tag":"Crea etiqueta",
    "Created":"Creat",
    "Created by":"Creat per",
    "Created on":"Creat el",
    "Current":"Actual",
    "Current password":"Contrasenya actual",
    "Dashboard":"Tauler",
    "Date":"Data",
    "Default":"Per defecte",
    "Delete activity":"Elimina activitat",
    "Delete organization":"Elimina organització",
    "Delete prompt":"Elimina consigna",
    "Delete role":"Elimina rol",
    "Delete tag":"Elimina etiqueta",
    "Delete user":"Elimina usuari",
    "Deleted":"Eliminat",
    "Details":"Detalls",
    "Disable":"Desactiva",
    "Disabled":"Desactivat",
    "Display":"Mostra",
    "Do you want to delete this activity?":"Vols eliminar aquesta activitat?",
    "Do you want to delete this group?":"Vols eliminar aquest grup?",
    "Do you want to delete this organization?":"Vols eliminar aquesta organització?",
    "Do you want to delete this prompt?":"Vols eliminar aquesta consigna?",
    "Do you want to delete this role?":"Vols eliminar aquest rol?",
    "Do you want to delete this tag?":"Vols eliminar aquesta etiqueta?",
    "Do you want to delete this user?":"Vols eliminar aquest usuari?",
    "Download":"Descarrega",
    "Drag and drop":"Arrossega i deixa anar",
    "Duration":"Durada",
    "Edit activity":"Edita activitat",
    "Edit organization":"Edita organització",
    "Edit prompt":"Edita consigna",
    "Edit role":"Edita rol",
    "Edit tag":"Edita etiqueta",
    "Edit user":"Edita usuari",
    "Email":"Correu electrònic",
    "Email address":"Adreça de correu electrònic",
    "Enable":"Activa",
    "Enabled":"Activat",
    "End":"Final",
    "End date":"Data de finalització",
    "Enter your email address":"Introdueix la teva adreça de correu electrònic",
    "Enter your password":"Introdueix la teva contrasenya",
    "Error":"Error",
    "Event":"Esdeveniment",
    "Events":"Esdeveniments",
    "Expand":"Desplega",
    "Export":"Exporta",
    "Failed":"Fallit",
    "Feedback":"Retroacció",
    "Field":"Camp",
    "File":"Fitxer",
    "Files":"Fitxers",
    "Filter":"Filtra",
    "Filters":"Filtres",
    "Rows per page":"Files per pàgina",
    "of":"de",
    "Clear":"Netejar",
    "Search by email, username, name, organization...":"Cercar per email, usuari, nom, organització...",
    "Search by organization name...":"Cercar per nom d'organització...",
    "New version available":"Nova versió disponible",
    "Version":"Versió",
    "is available. Reload to update.":"està disponible. Recarrega per actualitzar.",
    "Reload":"Recarregar",
    "Later":"Més tard",
    "First name":"Nom",
    "Folder":"Carpeta",
    "Folders":"Carpetes",
    "Format":"Format",
    "From":"Des de",
    "General":"General",
    "Generate":"Genera",
    "Go":"Vés",
    "Go back":"Torna enrere",
    "Go to":"Vés a",
    "Grade":"Qualificació",
    "Grades":"Qualificacions",
    "Group":"Grup",
    "Group @name has been deleted correctly":"El grup @name s'ha eliminat correctament",
    "Group @name has been updated correctly":"El grup @name s'ha actualitzat correctament",
    "Group created":"Grup creat",
    "Group created correctly":"Grup creat correctament",
    "Group deleted":"Grup eliminat",
    "Group name":"Nom del grup",
    "Group updated":"Grup actualitzat",
    "Groups":"Grups",
    "Help":"Ajuda",
    "Hide":"Amaga",
    "History":"Historial",
    "Home":"Inici",
    "ID":"ID",
    "Image":"Imatge",
    "Images":"Imatges",
    "Import":"Importa",
    "In progress":"En curs",
    "Inactive":"Inactiu",
    "Information":"Informació",
    "Instructions":"Instruccions",
    "Invalid":"No vàlid",
    "Invalid email address":"Adreça de correu electrònic no vàlida",
    "Invalid password":"Contrasenya no vàlida",
    "Invalid user":"Usuari no vàlid",
    "Language":"Idioma",
    "Last":"Últim",
    "Last accessed":"Últim accés",
    "Last modified":"Última modificació",
    "Last name":"Cognoms",
    "Learner":"Estudiant",
    "Learners":"Estudiants",
    "Level":"Nivell",
    "Link":"Enllaç",
    "Links":"Enllaços",
    "List":"Llista",
    "Load more":"Carrega'n més",
    "Loading":"Carregant",
    "Log in":"Inicia sessió",
    "Log out":"Tanca sessió",
    "Manage":"Gestiona",
    "Manage activities":"Gestiona activitats",
    "Manage groups":"Gestiona grups",
    "Manage organizations":"Gestiona organitzacions",
    "Manage prompts":"Gestiona consignes",
    "Manage roles":"Gestiona rols",
    "Manage tags":"Gestiona etiquetes",
    "Manage users":"Gestiona usuaris",
    "Member":"Membre",
    "Members":"Membres",
    "Menu":"Menú",
    "Message":"Missatge",
    "Messages":"Missatges",
    "Modified":"Modificat",
    "Modified by":"Modificat per",
    "Modified on":"Modificat el",
    "Module":"Mòdul",
    "Modules":"Mòduls",
    "My account":"El meu compte",
    "My activities":"Les meves activitats",
    "My groups":"Els meus grups",
    "My profile":"El meu perfil",
    "New":"Nou",
    "New activity":"Activitat nova",
    "New organization":"Organització nova",
    "New password":"Contrasenya nova",
    "New prompt":"Consigna nova",
    "New role":"Rol nou",
    "New tag":"Etiqueta nova",
    "New user":"Usuari nou",
    "Next":"Següent",
    "No activities available":"No hi ha activitats disponibles",
    "No activities found":"No s'han trobat activitats",
    "No content available":"No hi ha contingut disponible",
    "No data available":"No hi ha dades disponibles",
    "No description available":"No hi ha descripció disponible",
    "No groups available":"No hi ha grups disponibles",
    "No groups found":"No s'han trobat grups",
    "No items found":"No s'han trobat elements",
    "No organizations available":"No hi ha organitzacions disponibles",
    "No organizations found":"No s'han trobat organitzacions",
    "No prompts available":"No hi ha consignes disponibles",
    "No prompts found":"No s'han trobat consignes",
    "No results found":"No s'han trobat resultats",
    "No roles available":"No hi ha rols disponibles",
    "No roles found":"No s'han trobat rols",
    "No tags available":"No hi ha etiquetes disponibles",
    "No tags found":"No s'han trobat etiquetes",
    "No users available":"No hi ha usuaris disponibles",
    "No users found":"No s'han trobat usuaris",
    "Not available":"No disponible",
    "Not completed":"No completat",
    "Not published":"No publicat",
    "Not started":"No iniciat",
    "Notes":"Notes",
    "Notification":"Notificació",
    "Notifications":"Notificacions",
    "Number":"Número",
    "Of":"De",
    "OK":"D'acord",
    "Operations":"Operacions",
    "Options":"Opcions",
    "Order":"Ordre",
    "Organization":"Organització",
    "Organization @name has been deleted correctly":"L'organització @name s'ha eliminat correctament",
    "Organization @name has been updated correctly":"L'organització @name s'ha actualitzat correctament",
    "Organization created":"Organització creada",
    "Organization created correctly":"Organització creada correctament",
    "Organization deleted":"Organització eliminada",
    "Organization name":"Nom de l'organització",
    "Organization updated":"Organització actualitzada",
    "Organizations":"Organitzacions",
    "Owner":"Propietari",
    "Page":"Pàgina",
    "Parent":"Pare",
    "Password":"Contrasenya",
    "Password changed successfully":"Contrasenya canviada correctament",
    "Password reset":"Restabliment de contrasenya",
    "Pending":"Pendent",
    "Permission":"Permís",
    "Permissions":"Permisos",
    "Position":"Posició",
    "Previous":"Anterior",
    "Priority":"Prioritat",
    "Privacy":"Privacitat",
    "Proficiency":"Competència",
    "Proficiency level":"Nivell de competència",
    "Progress":"Progrés",
    "Prompt":"Prompt",
    "Prompt @name has been deleted correctly":"La consigna @name s'ha eliminat correctament",
    "Prompt @name has been updated correctly":"La consigna @name s'ha actualitzat correctament",
    "Prompt created":"Consigna creada",
    "Prompt created correctly":"Consigna creada correctament",
    "Prompt deleted":"Consigna eliminada",
    "Prompt name":"Nom de la consigna",
    "Prompt updated":"Consigna actualitzada",
    "Prompts":"Consignes",
    "Publish":"Publica",
    "Published":"Publicat",
    "Published on":"Publicat el",
    "Question":"Pregunta",
    "Questions":"Preguntes",
    "Recent":"Recent",
    "Recent activities":"Activitats recents",
    "Remove":"Elimina",
    "Remove from group":"Elimina del grup",
    "Report":"Informe",
    "Reports":"Informes",
    "Request":"Sol·licitud",
    "Required":"Obligatori",
    "Required field":"Camp obligatori",
    "Reset":"Restableix",
    "Reset password":"Restableix la contrasenya",
    "Resource":"Recurs",
    "Resources":"Recursos",
    "Response":"Resposta",
    "Responses":"Respostes",
    "Result":"Resultat",
    "Results":"Resultats",
    "Role":"Rol",
    "Role @name has been deleted correctly":"El rol @name s'ha eliminat correctament",
    "Role @name has been updated correctly":"El rol @name s'ha actualitzat correctament",
    "Role created":"Rol creat",
    "Role created correctly":"Rol creat correctament",
    "Role deleted":"Rol eliminat",
    "Role name":"Nom del rol",
    "Role updated":"Rol actualitzat",
    "Roles":"Rols",
    "Save and continue":"Desa i continua",
    "Save changes":"Desa els canvis",
    "Saved":"Desat",
    "Score":"Puntuació",
    "Search":"Cerca",
    "Search results":"Resultats de la cerca",
    "Select":"Selecciona",
    "Select a file":"Selecciona un fitxer",
    "Select a group":"Selecciona un grup",
    "Select a role":"Selecciona un rol",
    "Select all":"Selecciona-ho tot",
    "Select an option":"Selecciona una opció",
    "Select file":"Selecciona fitxer",
    "Selected":"Seleccionat",
    "Send":"Envia",
    "Session":"Sessió",
    "Settings":"Configuració",
    "Show":"Mostra",
    "Show all":"Mostra-ho tot",
    "Show less":"Mostra menys",
    "Show more":"Mostra més",
    "Sign in":"Inicia sessió",
    "Sign out":"Tanca sessió",
    "Sign up":"Registra't",
    "Size":"Mida",
    "Sort":"Ordena",
    "Sort by":"Ordena per",
    "Start":"Inici",
    "Start date":"Data d'inici",
    "Started":"Iniciat",
    "State":"Estat",
    "Statistics":"Estadístiques",
    "Status":"Estat",
    "Student":"Estudiant",
    "Students":"Estudiants",
    "Submit":"Envia",
    "Success":"Èxit",
    "Summary":"Resum",
    "System":"Sistema",
    "Tag":"Etiqueta",
    "Tag @name has been deleted correctly":"L'etiqueta @name s'ha eliminat correctament",
    "Tag @name has been updated correctly":"L'etiqueta @name s'ha actualitzat correctament",
    "Tag created":"Etiqueta creada",
    "Tag created correctly":"Etiqueta creada correctament",
    "Tag deleted":"Etiqueta eliminada",
    "Tag name":"Nom de l'etiqueta",
    "Tag updated":"Etiqueta actualitzada",
    "Tags":"Etiquetes",
    "Task":"Tasca",
    "Tasks":"Tasques",
    "Teacher":"Professor",
    "Teachers":"Professors",
    "The activity has been created successfully":"L'activitat s'ha creat correctament",
    "The activity has been deleted successfully":"L'activitat s'ha eliminat correctament",
    "The activity has been updated successfully":"L'activitat s'ha actualitzat correctament",
    "The group has been created successfully":"El grup s'ha creat correctament",
    "The group has been deleted successfully":"El grup s'ha eliminat correctament",
    "The group has been updated successfully":"El grup s'ha actualitzat correctament",
    "The organization has been created successfully":"L'organització s'ha creat correctament",
    "The organization has been deleted successfully":"L'organització s'ha eliminat correctament",
    "The organization has been updated successfully":"L'organització s'ha actualitzat correctament",
    "The password has been changed successfully":"La contrasenya s'ha canviat correctament",
    "The prompt has been created successfully":"La consigna s'ha creat correctament",
    "The prompt has been deleted successfully":"La consigna s'ha eliminat correctament",
    "The prompt has been updated successfully":"La consigna s'ha actualitzat correctament",
    "The role has been created successfully":"El rol s'ha creat correctament",
    "The role has been deleted successfully":"El rol s'ha eliminat correctament",
    "The role has been updated successfully":"El rol s'ha actualitzat correctament",
    "The tag has been created successfully":"L'etiqueta s'ha creat correctament",
    "The tag has been deleted successfully":"L'etiqueta s'ha eliminat correctament",
    "The tag has been updated successfully":"L'etiqueta s'ha actualitzat correctament",
    "The user has been created successfully":"L'usuari s'ha creat correctament",
    "The user has been deleted successfully":"L'usuari s'ha eliminat correctament",
    "The user has been updated successfully":"L'usuari s'ha actualitzat correctament",
    "This field is required":"Aquest camp és obligatori",
    "Time":"Hora",
    "To":"A",
    "Today":"Avui",
    "Tools":"Eines",
    "Total":"Total",
    "Unpublish":"Despublica",
    "Unpublished":"Despublicat",
    "Update activity":"Actualitza activitat",
    "Update group":"Actualitza grup",
    "Update organization":"Actualitza organització",
    "Update prompt":"Actualitza consigna",
    "Update role":"Actualitza rol",
    "Update tag":"Actualitza etiqueta",
    "Update user":"Actualitza usuari",
    "Updated":"Actualitzat",
    "Updated by":"Actualitzat per",
    "Updated on":"Actualitzat el",
    "Upload":"Puja",
    "Upload file":"Puja fitxer",
    "Uploaded":"Pujat",
    "User":"Usuari",
    "User @name has been deleted correctly":"L'usuari @name s'ha eliminat correctament",
    "User @name has been updated correctly":"L'usuari @name s'ha actualitzat correctament",
    "User account":"Compte d'usuari",
    "User created":"Usuari creat",
    "User created correctly":"Usuari creat correctament",
    "User deleted":"Usuari eliminat",
    "User name":"Nom d'usuari",
    "User profile":"Perfil d'usuari",
    "User updated":"Usuari actualitzat",
    "Username":"Nom d'usuari",
    "Valid":"Vàlid",
    "Value":"Valor",
    "View":"Visualitza",
    "View activity":"Visualitza activitat",
    "View all":"Visualitza-ho tot",
    "View details":"Visualitza detalls",
    "View group":"Visualitza grup",
    "View more":"Visualitza més",
    "View profile":"Visualitza perfil",
    "Visible":"Visible",
    "Warning":"Avís",
    "Website":"Lloc web",
    "Weight":"Pes",
    "Welcome":"Benvingut",
    "You are here":"Ets aquí",
    "You don't have permission to access this page":"No tens permís per accedir a aquesta pàgina",
    "You have been logged out":"Has tancat la sessió",
    "You must log in to access this page":"Has d'iniciar sessió per accedir a aquesta pàgina",
    "Your account":"El teu compte",
    "Your password has been reset":"La teva contrasenya s'ha restablert",
    "Search in all fields...":"Cercar en tots els camps...",
    "Searching...":"Cercant...",
    "Clear filters":"Netejar filtres",
    "Total results":"Resultats totals",
    "Searching for":"Cercant",
    "Translate with DeepL":"Traduir amb DeepL",
    "Translating...":"Traduint...",
    "Please enter text to translate":"Si us plau, introdueix el text a traduir",
    "Cannot translate to English (source language)":"No es pot traduir a l'anglès (idioma d'origen)",
    "Please enter English title first":"Si us plau, introdueix primer el títol en anglès",
    "Please enter English body first":"Si us plau, introdueix primer el cos en anglès",
    "Translation error: ":"Error de traducció: ",
    "You can add translations to other languages after creating the FAQ.":"Pots afegir traduccions a altres idiomes després de crear la FAQ.",
    "DeepL does not support Catalan":"DeepL no suporta català",
    "Please enter English teaser first":"Si us plau, introdueix primer el teaser en anglès",
    "Please enter English examples first":"Si us plau, introdueix primer els exemples en anglès",
    "Please enter English references first":"Si us plau, introdueix primer les referències en anglès",
    "Export User Events":"Exportar Events d'Usuari",
    "Export Users":"Exportar Usuaris",
    "Export Tasks":"Exportar Tasques",
    "Export Tasks Groups":"Exportar Grups de Tasques",
    "Export NLP Events":"Exportar Events NLP",
    "Reference":"Referència",
    "Teaching location":"Lloc d'ensenyament",
    "Teaching model":"Model d'ensenyament",
    "Teaching framework":"Marc d'ensenyament",
    "Teaching years":"Anys d'ensenyament",
    "User ID":"ID d'Usuari",
    "Number of pre-tasks":"Nombre de pre-tasques",
    "Number of subtasks":"Nombre de subtasques",
    "Number of post-tasks":"Nombre de post-tasques",
    "Number of sessions":"Nombre de sessions",
    "Cloned":"Clonat",
    "Original source":"Font original",
    "Original task":"Tasca original",
    "Task name":"Nom de tasca",
    "Subtask name":"Nom de subtasca",
    "Number of members":"Nombre de membres",
    "Add new Feedback":"Afegir nou Feedback",
    "Select the functionality of the application about which you want to comment":"Selecciona la funcionalitat de l'aplicació sobre la qual vols comentar",
    "Subject":"Assumpte",
    "Write the subject of your comment":"Escriu l'assumpte del teu comentari",
    "Leave your comments here":"Deixa els teus comentaris aquí",
    "Country":"País",
    "Region":"Regió",
    "Option":"Opció",
    "Analyze the text": "Analitza el text",
    "Text analysis": "Anàlisi del text",
    "Text analyzed in": "Text analitzat en",
    "Analysis language": "Idioma d'anàlisi",
    "The text will be analyzed in": "El text s'analitzarà en",
    "To change the analysis language, modify the task language in the task metadata section": "Per canviar l'idioma d'anàlisi, modifica l'idioma de la tasca a la secció de metadades de la tasca",
    "Important": "Important",
    "The tool is still under construction, but give it a try! We\'re working on it.": "L'eina encara està en construcció, però prova-la! Hi estem treballant.",
    "processing": "processant",
    "What is <span>taskGen</span>?":"Què és <span>taskGen</span>?",
    "Your session has expired. Please log in again.":"La teva sessió ha expirat. Si us plau, inicia sessió de nou.",
    "You do not have permission to perform this action.":"No tens permís per realitzar aquesta acció.",
    "The requested resource was not found.":"El recurs sol·licitat no s'ha trobat.",
    "Server error. Please try again later.":"Error del servidor. Si us plau, torna-ho a provar més tard.",
    "An error occurred. Please try again.":"S'ha produït un error. Si us plau, torna-ho a provar.",
    "Network error. Please check your connection.":"Error de xarxa. Si us plau, comprova la teva connexió.",
    "Can view":"Pot veure",
    "Can edit":"Pot editar",
    "All can view":"Tots poden veure",
    "All can edit":"Tots poden editar",
    "Show members":"Mostrar membres",
    "Hide members":"Amagar membres",
    "Group members":"Membres del grup",
    "You can edit this task":"Pots editar aquesta tasca",
    "members with access":"membres amb accés",
    "Select members and their permissions:":"Selecciona els membres i els seus permisos:",
    "Clear all":"Esborra tots",
    "Loading members...":"Carregant membres...",
    "Search by email or name...":"Cerca per email o nom...",
    "members":"membres",
    "Group members and their permissions:":"Membres del grup i els seus permisos:",
    "To change member permissions, edit the group in the Groups section.":"Per canviar els permisos dels membres, edita el grup a la secció de Grups.",
    "You can share the task <strong>{{taskName}}</strong> with other people.":"Pots compartir la tasca <strong>{{taskName}}</strong> amb altres persones.",
    "Add members to the group and set their permissions. These permissions will apply when sharing tasks with this group.":"Afegeix membres al grup i estableix els seus permisos. Aquests permisos s'aplicaran quan comparteixis tasques amb aquest grup.",
    "Click to add members:":"Fes clic per afegir membres:",
    "Group members:":"Membres del grup:",
    "All Tasks":"Totes les tasques",
    "New subfolder":"Nova subcarpeta",
    "New folder":"Nova carpeta",
    "New task":"Nova tasca",
    "- Tag -":"- Etiqueta -",
    "- Level -":"- Nivell -",
    "- Aim -":"- Objectiu -",
    "Icon view":"Vista d'icones",
    "List view":"Vista de llista",
    "Create folder":"Crear carpeta",
    "New Folder":"Nova carpeta",
    "Create task":"Crear tasca",
    "New Task":"Nova tasca",
    "This folder is empty":"Aquesta carpeta és buida",
    "Create a new task or folder, or drag items here":"Crea una nova tasca o carpeta, o arrossega elements aquí",
    "No tasks match the filters":"Cap tasca coincideix amb els filtres",
    "Try adjusting or clearing the filters":"Prova d'ajustar o netejar els filtres",
    "Open":"Obrir",
    "No members in this group":"No hi ha membres en aquest grup",
    "Passwords do not match":"Les contrasenyes no coincideixen",
    "Password updated successfully.":"La contrasenya s'ha actualitzat correctament.",
    "This reset link is invalid or has expired.":"Aquest enllaç de restabliment no és vàlid o ha caducat.",
    "Back to login":"Tornar a l'inici de sessió",
    "Update password":"Actualitzar contrasenya",
    "We've sent you an email with a link to reset your password.":"T'hem enviat un correu electrònic amb un enllaç per restablir la teva contrasenya.",
    "We are working to improve the Taskgen site.":"Estem treballant per millorar el lloc de Taskgen.",
    "Anguilla":"Anguilla",
    "Barbados":"Barbados",
    "Bolivia (Plurinational State of)":"Bolívia (Estat Plurinacional de)",
    "Bonaire, Sint Eustatius and Saba":"Bonaire, Sint Eustatius i Saba",
    "Botswana":"Botswana",
    "British Indian Ocean Territory (the)":"Territori Britànic de l'Oceà Índic",
    "Bulgaria":"Bulgària",
    "Burkina Faso":"Burkina Faso",
    "Cambodia":"Cambodja",
    "Cameroon":"Camerun",
    "Cayman Islands (the)":"Illes Caiman",
    "Chad":"Txad",
    "Christmas Island":"Illa Christmas",
    "Colombia":"Colòmbia",
    "Cuba":"Cuba",
    "Djibouti":"Djibouti",
    "Dominica":"Dominica",
    "Dominican Republic (the)":"República Dominicana",
    "Eswatini":"Eswatini",
    "Ethiopia":"Etiòpia",
    "Fiji":"Fiji",
    "French Polynesia":"Polinèsia Francesa",
    "Gambia (the)":"Gàmbia",
    "Guam":"Guam",
    "Guernsey":"Guernsey",
    "Honduras":"Hondures",
    "Iraq":"Iraq",
    "Kiribati":"Kiribati",
    "Malaysia":"Malàisia",
    "Maldives":"Maldives",
    "Mali":"Mali",
    "Micronesia (Federated States of)":"Micronèsia (Estats Federats de)",
    "Mongolia":"Mongòlia",
    "Niue":"Niue",
    "Oman":"Oman",
    "Pakistan":"Pakistan",
    "Papua New Guinea":"Papua Nova Guinea",
    "Paraguay":"Paraguai",
    "Peru":"Perú",
    "Pitcairn":"Pitcairn",
    "Portugal":"Portugal",
    "Russian Federation (the)":"Federació Russa",
    "Saint Barthélemy":"Saint Barthélemy",
    "Saint Helena, Ascension and Tristan da Cunha":"Santa Helena, Ascensió i Tristan da Cunha",
    "Saint Vincent and the Grenadines":"Saint Vincent i les Grenadines",
    "Saudi Arabia":"Aràbia Saudita",
    "Sierra Leone":"Sierra Leone",
    "Slovakia":"Eslovàquia",
    "Slovenia":"Eslovènia",
    "South Africa":"Sud-àfrica",
    "South Georgia and the South Sandwich Islands":"Geòrgia del Sud i les Illes Sandwich del Sud",
    "Suriname":"Surinam",
    "Syrian Arab Republic":"República Àrab Siriana",
    "Tanzania, United Republic of":"Tanzània, República Unida de",
    "Thailand":"Tailàndia",
    "Togo":"Togo",
    "Turkmenistan":"Turkmenistan",
    "Viet Nam":"Vietnam",
    "Virgin Islands (British)":"Illes Verges Britàniques",
    "Zimbabwe":"Zimbabwe",
    "terms and conditions":"termes i condicions",
    "Add new Task Example":"Afegir un nou exemple de tasca",
    "Select the tasks you want to add as examples:":"Seleccioneu les tasques que voleu afegir com a exemples:",
    "Add selected tasks":"Afegir les tasques seleccionades",
    "Delete Task Example":"Eliminar exemple de tasca",
    "You are about to delete the task example":"Esteu a punt d'eliminar l'exemple de tasca",
    "This action cannot be undone.":"Aquesta acció no es pot desfer.",
    "Are you sure you want to proceed?":"Esteu segur que voleu continuar?",
    "No task example selected.":"Cap exemple de tasca seleccionat.",
    "New Task Example":"Nou exemple de tasca",
    "Move up":"Moure amunt",
    "Move down":"Moure avall",
    "Delete task example":"Eliminar exemple de tasca",
    "You are not allowed to access this secion.":"No teniu permís per accedir a aquesta secció.",
    "Subgroup":"Subgrup",
    "Timestamp":"Marca de temps",
    "Add new FAQ":"Afegir nova PMF",
    "Enter a title":"Introduïu un títol",
    "Enter a weigh":"Introduïu un pes",
    "Delete FAQ":"Eliminar PMF",
    "You are about to delete FAQ content":"Esteu a punt d'eliminar el contingut de la PMF",
    "Edit FAQ":"Editar PMF",
    "No FAQ selected.":"Cap PMF seleccionada.",
    "New FAQ":"Nova PMF",
    "Delete feedback":"Eliminar comentari",
    "You are about to delete feedback content":"Esteu a punt d'eliminar el contingut del comentari",
    "Feedback management":"Gestió de comentaris",
    "Issue":"Incidència",
    "Section":"Secció",
    "You are not allowed to access this section.":"No teniu permís per accedir a aquesta secció.",
    "Add new help":"Afegir nova ajuda",
    "Help items":"Elements d'ajuda",
    "There are no help items defined. Add your first help item.":"No hi ha elements d'ajuda definits. Afegiu el vostre primer element d'ajuda.",
    "Edit help":"Editar ajuda",
    "Add help item":"Afegir element d'ajuda",
    "Teaser":"Resum",
    "More link":"Enllaç de més informació",
    "Text for the more link":"Text per a l'enllaç de més informació",
    "Enter the title":"Introduïu el títol",
    "Examples":"Exemples",
    "References":"Referències",
    "Modify":"Modificar",
    "Delete help":"Eliminar ajuda",
    "You are about to delete help content":"Esteu a punt d'eliminar el contingut d'ajuda",
    "Enter a descriptive name":"Introduïu un nom descriptiu",
    "Help item":"Element d'ajuda",
    "Enter the position of this help content relative to other help contents. The higher the value the lower it will be sorted.":"Introduïu la posició d'aquest contingut d'ajuda respecte a altres continguts d'ajuda. Com més alt sigui el valor, més avall es mostrarà.",
    "Edit Help Item":"Editar element d'ajuda",
    "Are you sure you want to delete Help Item named?":"Esteu segur que voleu eliminar l'element d'ajuda anomenat?",
    "No help selected.":"Cap ajuda seleccionada.",
    "Help management":"Gestió d'ajuda",
    "New help":"Nova ajuda",
    "You are about to delete organization content":"Esteu a punt d'eliminar el contingut de l'organització",
    "Edit Organization":"Editar organització",
    "Organizations management":"Gestió d'organitzacions",
    "Edit organizataion":"Editar organització",
    "You must generate a password for the user. Use the button below.":"Heu de generar una contrasenya per a l'usuari. Utilitzeu el botó de sota.",
    "You must give the user a role.":"Heu d'assignar un rol a l'usuari.",
    "Lastname":"Cognom",
    "Write the name of the user":"Escriviu el nom de l'usuari",
    "Write the lastname of the user":"Escriviu el cognom de l'usuari",
    "Generate password":"Generar contrasenya",
    "You are about to delete user with email":"Esteu a punt d'eliminar l'usuari amb el correu electrònic",
    "All user data and tasks will be deleted. This action cannot be undone.":"Totes les dades i tasques de l'usuari seran eliminades. Aquesta acció no es pot desfer.",
    "You must generate or write a password for the user. Use the button below.":"Heu de generar o escriure una contrasenya per a l'usuari. Utilitzeu el botó de sota.",
    "Users management":"Gestió d'usuaris",
    "Mail":"Correu electrònic",
    "Only MP4 videos are allowed.":"Només es permeten vídeos MP4.",
    "Add new Video":"Afegir nou vídeo",
    "Delete Video":"Eliminar vídeo",
    "You are about to delete Video content":"Esteu a punt d'eliminar el contingut del vídeo",
    "Edit Video":"Editar vídeo",
    "No Video selected.":"Cap vídeo seleccionat.",
    "Video management":"Gestió de vídeos",
    "New Video":"Nou vídeo",
    "Beginnings are always difficult":"Els inicis sempre són difícils",
    "Do not hesitate to contact us with any questions you may have.":"No dubteu a contactar-nos amb qualsevol pregunta que tingueu.",
    "Contact us":"Contacta'ns",
    "Check out some of the questions teachers/designers have asked us so far. The answers will help you to get the most of the tool":"Consulteu algunes de les preguntes que els professors/dissenyadors ens han fet fins ara. Les respostes us ajudaran a treure el màxim profit de l'eina",
    "Pretasks":"Pretasques",
    "Postasks":"Postasques",
    "Task groups":"Grups de la tasca",
    "Task roles":"Rols de la tasca",
    "Task prompts":"Consignes de la tasca",
    "Text analyzer":"Analitzador de text",
    "Help system":"Sistema d'ajuda",
    "It is an ongoing three-year research project made possible by a grant PID2023-149648NB-I00 funded by the Ministry of Science and Innovation (MCIN) and National Research Agency (AEI) 10.13039/501100011033.":"És un projecte de recerca de tres anys en curs, possible gràcies a una subvenció PID2023-149648NB-I00 finançada pel Ministeri de Ciència i Innovació (MCIN) i l'Agència Estatal d'Investigació (AEI) 10.13039/501100011033.",
    "In this project we are developing and piloting a tool that will help teachers and task and syllabus designers with organizing and automating the design of second/foreign language communicative tasks. If you wish to know more about the project, please click here...":"En aquest projecte estem desenvolupant i provant una eina que ajudarà els professors i els dissenyadors de tasques i programes amb l'organització i l'automatització del disseny de tasques comunicatives de segones llengües / llengües estrangeres. Si voleu saber-ne més sobre el projecte, feu clic aquí...",
    "Read more":"Llegir més",
    "Wish to design a task?":"Vols dissenyar una tasca?",
    "or get some inspiration":"o inspira't",
    "See some examples":"Veure alguns exemples",
    "Create a new task":"Crear una nova tasca",
    "Shared directly with me":"Compartides directament amb mi",
    "Task examples":"Exemples de tasques",
    "<p>You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.</p>":"<p>Podeu trobar inspiració sobre possibles pretasques al Banc Internacional de Tasques, on podeu obtenir i descarregar dissenys complets de tasques.</p>",
    "<p>Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards</p>":"<p>Quizlet és una eina que permet als estudiants aprendre vocabulari mitjançant targetes personalitzades.</p>",
    "<p>If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.</p>":"<p>Si sou a primària o secundària, aquí teniu una llista d'eines d'IA que podeu utilitzar per a la vostra docència. El registre i l'ús de les eines és gratuït.<br /> Podeu portar els resultats d'aquestes eines i enganxar-los al quadre de text de taskGen.</p>",
    "<p>edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.</p>":"<p>edpuzzle us permetrà <strong>crear vídeos interactius</strong> on les preguntes apareixen mentre miren el vídeo. Podeu incloure l'enllaç al vídeo d'edpuzzle al quadre de text de taskGen.</p>",
    "<p>The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.</p>":"<p>El programa pot <strong>generar vídeos</strong> en funció del tema que trieu. Teniu accés limitat com a usuari gratuït.<br /> També podeu inserir l'enllaç a taskGen o pujar els fitxers d'àudio que creeu amb aquestes aplicacions.</p>",
    "<p>You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.</p>":"<p>Podeu inserir un text i fer que el programa <strong>us llegeixi el text</strong>. Teniu accés limitat com a usuari gratuït.</p>",
    "<p>Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.</p>":"<p>Quizbot us permetrà <strong>transformar un fitxer d'àudio en text</strong> i després <strong>generar preguntes</strong>.<br /> Podeu copiar i enganxar les preguntes al quadre de text de taskGen. També podeu inserir l'enllaç a taskGen o pujar els fitxers d'àudio que creeu amb aquestes aplicacions.</p>",
    "<p>Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.</p>":"<p>Dos llocs web clàssics on podeu <strong>trobar guions de pel·lícules</strong> i guions de <strong>sèries de televisió</strong>.</p>",
    "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it'll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function \"Analyze\" to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)</p>":"<p>Utilitzeu aquesta eina per <strong>generar un diàleg</strong>. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.<br /> Podeu copiar i enganxar els diàlegs al quadre de text de taskGen. Després podeu utilitzar la funció \"Analitzar\" per obtenir una anàlisi completa de les característiques lingüístiques del text. Podeu ressaltar automàticament o canviar la mida de la font per destacar aquestes característiques (millora de l'entrada).</p>",
    "<p>You can <strong>generate new pictures</strong>.</p>":"<p>Podeu <strong>generar noves imatges</strong>.</p>",
    "<p>You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.</p>":"<p>Podeu pujar una imatge i el programa <strong>generarà preguntes</strong> sobre la imatge automàticament.</p>",
    "<p>You can use this tool to <strong>have a text be read</strong> by a computerized voice.</p>":"<p>Podeu utilitzar aquesta eina perquè <strong>un text sigui llegit</strong> per una veu sintetitzada.</p>",
    "<p>You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.</p>":"<p>Podeu inserir un text i fer que el programa <strong>us llegeixi el text</strong>. Teniu accés limitat com a usuari gratuït. Podeu copiar l'enllaç al quadre de text de taskGen o pujar el fitxer d'àudio a la vostra pretasca de transcripció oral.</p>",
    "<p>You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.</p>":"<p>Podeu <strong>obtenir idees</strong> i exemples sobre activitats d'interacció al Banc Internacional de Tasques.</p>",
    "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it'll give you a perfectly crafted dialogue for you.</p>":"<p>Utilitzeu aquesta eina per <strong>generar un diàleg</strong>. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.</p>",
    "AI Tools and other resources":"Eines d'IA i altres recursos",
    "Pragmatic Expressions":"Expressions pragmàtiques",
    "All pragmatic expressions":"Totes les expressions pragmàtiques",
    "Suggesting":"Suggerir",
    "Thanking":"Agrair",
    "Requesting":"Demanar",
    "Agreeing/Disagreeing":"Estar d'acord/En desacord",
    "Showing interest":"Mostrar interès",
    "Apologising":"Disculpar-se",
    "Giving an opinion":"Donar una opinió",
    "Greeting":"Saludar",
    "Phrasal verbs":"Verbs frasals",
    "Word Categories":"Categories de paraules",
    "Irregular plurals":"Plurals irregulars",
    "Comparative adjectives":"Adjectius comparatius",
    "Superlative adjectives":"Adjectius superlatius",
    "Comparative adverbs":"Adverbis comparatius",
    "Superlative adverbs":"Adverbis superlatius",
    "Wh-adverb":"Adverbi interrogatiu",
    "Irregular verbs":"Verbs irregulars",
    "Verb Tense":"Temps verbal",
    "Present Simple":"Present Simple",
    "Present Perfect":"Present Perfect",
    "Present Perfect Continuous":"Present Perfect Continuous",
    "Past Simple":"Past Simple",
    "Past Continuous":"Past Continuous",
    "Past Perfect":"Past Perfect",
    "Past Perfect Continuous":"Past Perfect Continuous",
    "Future \u2018going to\u2019":"Futur \u2018going to\u2019",
    "Future 'going to'":"Futur 'going to'",
    "Future Simple":"Future Simple",
    "Future Perfect":"Future Perfect",
    "Future Perfect Continuous":"Future Perfect Continuous",
    "Passive":"Passiva",
    "Present Simple Passive":"Present Simple Passiu",
    "Present Continuous Passive":"Present Continuous Passiu",
    "Present Perfect Passive":"Present Perfect Passiu",
    "Present Perfect Continuous Passive":"Present Perfect Continuous Passiu",
    "Past Simple Passive":"Past Simple Passiu",
    "Past Continuous Passive":"Past Continuous Passiu",
    "Past Perfect Passive":"Past Perfect Passiu",
    "Past Perfect Continuous Passive":"Past Perfect Continuous Passiu",
    "Future Simple Passive":"Future Simple Passiu",
    "Future Perfect Passive":"Future Perfect Passiu",
    "Modal Verbs":"Verbs modals",
    "Imperative":"Imperatiu",
    "Subordinating conjunctions":"Conjuncions subordinants",
    "Determiner":"Determinant",
    "Wh-Determiner":"Determinant interrogatiu",
    "Wh-pronouns":"Pronoms interrogatius",
    "Possessive wh-pronoun":"Pronom possessiu interrogatiu",
    "Possessive Pronouns":"Pronoms possessius",
    "Clone as Pos-task":"Clonar com a postasca",
    "Clone as Pre-task":"Clonar com a pretasca",
    "We are sorry! There was a processing error. Text Analysis is out of order at this moment. Give us some time to recover and try again later.":"Ho sentim! S'ha produït un error de processament. L'anàlisi de text no funciona en aquest moment. Doneu-nos una mica de temps per recuperar-nos i torneu-ho a provar més tard.",
    "hour":"hora",
    "hours":"hores",
    "minute":"minut",
    "minutes":"minuts",
    "second":"segon",
    "seconds":"segons",
    "Previously formatted text":"Text formatat anteriorment",
    "read more...":"llegir més...",
    "Drag and Drop files here":"Arrossegueu i deixeu anar els fitxers aquí",
    "Click on the plus icon of each user you want to select:":"Feu clic a la icona de més de cada usuari que voleu seleccionar:",
    "Users selected:":"Usuaris seleccionats:",
    "Users Groups":"Grups d'usuaris",
    "FAQs":"PMF",
    "Feedbacks":"Comentaris",
    "Help index":"Índex d'ajuda",
    "Video tutorials":"Tutorials en vídeo",
    "To describe an object, person or place":"Descriure un objecte, persona o lloc",
    "To solve a communication problem or gap":"Resoldre un problema o buit de comunicació",
    "To create a design or plan":"Crear un disseny o pla",
    "To to make a decision or choice":"Prendre una decisió o elecció",
    "To explain a process":"Explicar un procés",
    "To tell a story":"Explicar una història",
    "To reach an agreement":"Arribar a un acord",
    "To learn new content (focus on meaning)":"Aprendre contingut nou (enfocament en el significat)",
    "To fill out a form":"Omplir un formulari",
    "To make a complaint":"Fer una queixa",
    "To request information":"Sol·licitar informació",
    "To formulate an argument":"Formular un argument",
    "To express an opinion":"Expressar una opinió",
    "To foster critical language awareness":"Fomentar la consciència lingüística crítica",
    "A1 Movers":"A1 Movers",
    "A2 Key":"A2 Key",
    "B1 Preliminary":"B1 Preliminary",
    "B2 First":"B2 First",
    "C1 Advanced":"C1 Advanced",
    "C2 Proficiency":"C2 Proficiency",
    "Edit Post-Task: Audio":"Editar postasca: Àudio",
    "Title of the Post-Task":"Títol de la postasca",
    "Teacher notes":"Notes del professor",
    "Edit Post-Task: Written Dialogue":"Editar postasca: Diàleg escrit",
    "Edit Post-Task: Exercises":"Editar postasca: Exercicis",
    "Edit Post-Task: Explicit Explanation":"Editar postasca: Explicació explícita",
    "Edit Post-Task: Game":"Editar postasca: Joc",
    "Edit Post-Task: Interaction Activity":"Editar postasca: Activitat d'interacció",
    "Edit Post-Task: Photo":"Editar postasca: Foto",
    "Edit Post-Task: Repetition":"Editar postasca: Repetició",
    "Edit Post-Task: Written to Oral / Oral to Written":"Editar postasca: Escrit a oral / Oral a escrit",
    "Edit Post-Task: Teacher Feedback":"Editar postasca: Retroalimentació del professor",
    "Edit Post-Task: Text":"Editar postasca: Text",
    "Edit Post-Task: Task model and exercises":"Editar postasca: Model de tasca i exercicis",
    "Edit Post-Task: Video":"Editar postasca: Vídeo",
    "New Post-Task: Audio":"Nova postasca: Àudio",
    "New Post-Task: Written Dialogue":"Nova postasca: Diàleg escrit",
    "New Post-Task: Exercises":"Nova postasca: Exercicis",
    "New Post-Task: Explicit Explanation":"Nova postasca: Explicació explícita",
    "New Post-Task: Game":"Nova postasca: Joc",
    "New Post-Task: Interaction Activity":"Nova postasca: Activitat d'interacció",
    "New Post-Task: Photo":"Nova postasca: Foto",
    "New Post-Task: Repetition":"Nova postasca: Repetició",
    "New Post-Task: Written to Oral / Oral to Written":"Nova postasca: Escrit a oral / Oral a escrit",
    "New Post-Task: Teacher Feedback":"Nova postasca: Retroalimentació del professor",
    "New Post-Task: Text":"Nova postasca: Text",
    "New Post-Task: Task model and exercises":"Nova postasca: Model de tasca i exercicis",
    "New Post-Task: Video":"Nova postasca: Vídeo",
    "This post-task has no text":"Aquesta postasca no té text",
    "Edit Pre-Task: Interaction activity":"Editar pretasca: Activitat d'interacció",
    "Title of the Pre-Task":"Títol de la pretasca",
    "Edit Pre-Task: Audio":"Editar pretasca: Àudio",
    "Edit Pre-Task: Written Dialogue":"Editar pretasca: Diàleg escrit",
    "Edit Pre-Task: Game":"Editar pretasca: Joc",
    "Edit Pre-Task: Photo":"Editar pretasca: Foto",
    "Edit Pre-Task: Speech transcript":"Editar pretasca: Transcripció oral",
    "Edit Pre-Task: Text":"Editar pretasca: Text",
    "Edit Pre-Task: Video":"Editar pretasca: Vídeo",
    "Edit Pre-Task: Warm-up":"Editar pretasca: Escalfament",
    "New Pre-Task: Interaction activity":"Nova pretasca: Activitat d'interacció",
    "New Pre-Task: Audio":"Nova pretasca: Àudio",
    "New Pre-Task: Written Dialogue":"Nova pretasca: Diàleg escrit",
    "New Pre-Task: Game":"Nova pretasca: Joc",
    "New Pre-Task: Photo":"Nova pretasca: Foto",
    "New Pre-Task: Speech transcript":"Nova pretasca: Transcripció oral",
    "New Pre-Task: Text":"Nova pretasca: Text",
    "New Pre-Task: Video":"Nova pretasca: Vídeo",
    "New Pre-Task: Warm-up":"Nova pretasca: Escalfament",
    "No text specified for this pre-task":"No s'ha especificat cap text per a aquesta pretasca",
    "Edit Main Task":"Editar tasca principal",
    "There are no groups":"No hi ha grups",
    "There are no roles":"No hi ha rols",
    "There are no prompts defined":"No hi ha consignes definides",
    "This prompt has no text":"Aquesta consigna no té text",
    "Belongs to groups":"Pertany als grups",
    "Are you sure you want to delete the student? This action cannot be undone.":"Esteu segur que voleu eliminar l'estudiant? Aquesta acció no es pot desfer.",
    "Edit student":"Editar estudiant",
    "Delete student":"Eliminar estudiant",
    "Are you sure you want to delete the group? This action cannot be undone.":"Esteu segur que voleu eliminar el grup? Aquesta acció no es pot desfer.",
    "Change color":"Canviar color",
    "Add new student":"Afegir nou estudiant",
    "Edit name":"Editar nom",
    "Clone":"Clonar",
    "Title of the Prompt":"Títol de la consigna",
    "Are you sure you want to delete the prompt? This action cannot be undone.":"Esteu segur que voleu eliminar la consigna? Aquesta acció no es pot desfer.",
    "Clone prompt":"Clonar consigna",
    "Are you sure you want to delete the role? This action cannot be undone.":"Esteu segur que voleu eliminar el rol? Aquesta acció no es pot desfer.",
    "Assignments for the role:":"Assignacions per al rol:",
    "Select the groups this role is assigned to":"Seleccioneu els grups als quals s'assigna aquest rol",
    "Clone task":"Clonar tasca",
    "Edit task":"Editar tasca",
    "Are you sure you want to delete?":"Esteu segur que voleu eliminar?",
    "You are about to delete the task":"Esteu a punt d'eliminar la tasca",
    "The task":"La tasca",
    "is already shared with you.":"ja està compartida amb tu.",
    "Do you want to add the task":"Vols afegir la tasca",
    "to the collection of tasks shared with you?":"a la col·lecció de tasques compartides amb tu?",
    "Pre-Task has been clonned as a Pos-Task.":"La pretasca s'ha clonat com a postasca.",
    "Are you sure you want to delete the post-task?":"Esteu segur que voleu eliminar la postasca?",
    "Are you sure you want to delete the pre-task":"Esteu segur que voleu eliminar la pretasca",
    "User or password are not valid":"L'usuari o la contrasenya no són vàlids",
    "Log in using your email":"Inicia sessió amb el teu correu electrònic",
    "My task designs":"Els meus dissenys de tasques",
    "Shared with me":"Compartides amb mi",
    "User groups":"Grups d'usuaris",
    "Add help Item":"Afegir element d'ajuda",
    "Are you sure you want to delete this section? Tasks in this section will be moved to 'Unsectioned'.":"Esteu segur que voleu eliminar aquesta secció? Les tasques d'aquesta secció es mouran a 'Sense secció'.",
    "Are you sure you want to delete this tag? This action cannot be undone.":"Esteu segur que voleu eliminar aquesta etiqueta? Aquesta acció no es pot desfer.",
    "By clicking this box, I state that I have read and understood the ":"En fer clic en aquesta casella, declaro que he llegit i entès els ",
    "Create Section":"Crear secció",
    "Create a new section":"Crear una nova secció",
    "DD/MM/YYYY":"DD/MM/AAAA",
    "DD/MM/YYYY hh:mm":"DD/MM/AAAA hh:mm",
    "Delete section":"Eliminar secció",
    "Discard":"Descartar",
    "Download DOCX":"Descarregar DOCX",
    "Downloading...":"Descarregant...",
    "Edit Section":"Editar secció",
    "Edit section":"Editar secció",
    "Enter section name":"Introduïu el nom de la secció",
    "If you accept, you will find this task in the 'Shared with me' section. From there you will be able to clone it and create your own version of the task.":"Si accepteu, trobareu aquesta tasca a la secció 'Compartides amb mi'. Des d'allà podreu clonar-la i crear la vostra pròpia versió de la tasca.",
    "If you are in primary or secondary, here's a list of AI tools you can use to assist your teaching. Signing up and using the tools is free.<br /> You can bring the outcomes of those tools and cut and paste them into the taskGen textbox.":"Si sou a primària o secundària, aquí teniu una llista d'eines d'IA que podeu utilitzar per a la vostra docència. El registre i l'ús de les eines és gratuït.<br /> Podeu portar els resultats d'aquestes eines i enganxar-los al quadre de text de taskGen.",
    "Login or register":"Iniciar sessió o registrar-se",
    "No prompt assigned":"Cap consigna assignada",
    "No role assigned":"Cap rol assignat",
    "No tasks in this section":"No hi ha tasques en aquesta secció",
    "No user selected.":"Cap usuari seleccionat.",
    "Not translated":"No traduït",
    "Number of students":"Nombre d'estudiants",
    "Pos-task":"Postasca",
    "Pre-task":"Pretasca",
    "Print":"Imprimir",
    "Quizbot will let you <strong>transform an audio file into text</strong> and then <strong>generate questions</strong>.<br /> You can copy and paste the question into the taskGen text box. You can also insert the link in taskGen or upload the audio files you create with these apps.":"Quizbot us permetrà <strong>transformar un fitxer d'àudio en text</strong> i després <strong>generar preguntes</strong>.<br /> Podeu copiar i enganxar les preguntes al quadre de text de taskGen. També podeu inserir l'enllaç a taskGen o pujar els fitxers d'àudio que creeu amb aquestes aplicacions.",
    "Quizlet is a tool that allows students to learn vocabulary by means of customised flashcards":"Quizlet és una eina que permet als estudiants aprendre vocabulari mitjançant targetes personalitzades",
    "Section Name":"Nom de la secció",
    "Thanks for your feedback.":"Gràcies pel vostre comentari.",
    "The program can <strong>generate videos</strong> on the basis of the topic you choose. You have limited access as a free user.<br /> You can also insert the link in taskGen or upload the audio files you create with these apps.":"El programa pot <strong>generar vídeos</strong> en funció del tema que trieu. Teniu accés limitat com a usuari gratuït.<br /> També podeu inserir l'enllaç a taskGen o pujar els fitxers d'àudio que creeu amb aquestes aplicacions.",
    "There are no post-tasks defined":"No hi ha postasques definides",
    "There are no prompts":"No hi ha consignes",
    "There are no tasks defined":"No hi ha tasques definides",
    "There was a problem uploading files. You can upload a maximum of 5 files simultaneously and not more than 50MB. Try reducing file sizes or uploading fewer files simultaneously. If the problem persists, contact us.":"Hi ha hagut un problema en pujar els fitxers. Podeu pujar un màxim de 5 fitxers simultàniament i no més de 50 MB. Proveu de reduir la mida dels fitxers o de pujar-ne menys simultàniament. Si el problema persisteix, contacteu-nos.",
    "This tag already exists.":"Aquesta etiqueta ja existeix.",
    "To use this link, you must have a TaskGen account. Go to the login page and access with your account or register.":"Per utilitzar aquest enllaç, heu de tenir un compte de TaskGen. Aneu a la pàgina d'inici de sessió i accediu amb el vostre compte o registreu-vos.",
    "Translations":"Traduccions",
    "Two classic web sites where you can <strong>find movie scripts</strong> and scripts from <strong>TV series</strong>.":"Dos llocs web clàssics on podeu <strong>trobar guions de pel·lícules</strong> i guions de <strong>sèries de televisió</strong>.",
    "Unsectioned":"Sense secció",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it'll give you a perfectly crafted dialogue for you.":"Utilitzeu aquesta eina per <strong>generar un diàleg</strong>. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it'll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function \"Analyze\" to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)":"Utilitzeu aquesta eina per <strong>generar un diàleg</strong>. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.<br /> Podeu copiar i enganxar els diàlegs al quadre de text de taskGen. Després podeu utilitzar la funció \"Analitzar\" per obtenir una anàlisi completa de les característiques lingüístiques del text. Podeu ressaltar automàticament o canviar la mida de la font per destacar aquestes característiques (millora de l'entrada).",
    "Write a tag name":"Escriviu un nom d'etiqueta",
    "YYYY-MM-DD":"AAAA-MM-DD",
    "YYYY-MM-DD hh:mm:ss":"AAAA-MM-DD hh:mm:ss",
    "YYYYMMDD":"AAAAMMDD",
    "You can <strong>generate new pictures</strong>.":"Podeu <strong>generar noves imatges</strong>.",
    "You can <strong>get ideas</strong> and example about interaction activities in the International Task Bank.":"Podeu <strong>obtenir idees</strong> i exemples sobre activitats d'interacció al Banc Internacional de Tasques.",
    "You can add users of your organization or any user in taskGen.":"Podeu afegir usuaris de la vostra organització o qualsevol usuari de taskGen.",
    "You can get some inspiration about possible pre-tasks in the International Task Bank where you can obtain and download full task designs.":"Podeu trobar inspiració sobre possibles pretasques al Banc Internacional de Tasques, on podeu obtenir i descarregar dissenys complets de tasques.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user.":"Podeu inserir un text i fer que el programa <strong>us llegeixi el text</strong>. Teniu accés limitat com a usuari gratuït.",
    "You can insert a text and have the program <strong>read the text for you</strong>. You have limited access as a free user. You can copy the link in the taskGen text box or upload the audio file onto to your speech transcript pre-task.":"Podeu inserir un text i fer que el programa <strong>us llegeixi el text</strong>. Teniu accés limitat com a usuari gratuït. Podeu copiar l'enllaç al quadre de text de taskGen o pujar el fitxer d'àudio a la vostra pretasca de transcripció oral.",
    "You can upload a picture and the program will <strong>generate questions</strong> about the picture automatically.":"Podeu pujar una imatge i el programa <strong>generarà preguntes</strong> sobre la imatge automàticament.",
    "You can use this tool to <strong>have a text be read</strong> by a computerized voice.":"Podeu utilitzar aquesta eina perquè <strong>un text sigui llegit</strong> per una veu sintetitzada.",
    "[video ":"[vídeo ",
    "[video=":"[vídeo=",
    "a":"a",
    "edpuzzle will let you <strong>create interactive videos</strong> where questions appear as they watch the video. You can include the link to the edpuzzle video in the taskGen text box.":"edpuzzle us permetrà <strong>crear vídeos interactius</strong> on les preguntes apareixen mentre miren el vídeo. Podeu incloure l'enllaç al vídeo d'edpuzzle al quadre de text de taskGen.",
    "not used":"no utilitzat",
    "students":"estudiants",
    "used by":"utilitzat per",
    "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)</p>":"<p>Utilitzeu aquesta eina per <strong>generar un diàleg</strong>. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.<br /> Podeu copiar i enganxar els diàlegs al quadre de text de taskGen. Després podeu utilitzar la funció “Analitzar” per obtenir una anàlisi completa de les característiques lingüístiques del text. Podeu ressaltar automàticament o canviar la mida de la font per destacar aquestes característiques (millora de l’entrada).</p>",
    "<p>Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.</p>":"<p>Utilitzeu aquesta eina per <strong>generar un diàleg</strong>. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.</p>",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.":"Utilitzeu aquesta eina per generar un diàleg. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat.",
    "Use this tool to <strong>generate a dialogue</strong>. Just describe your objective and a bit of a context, and it’ll give you a perfectly crafted dialogue for you.<br /> You can copy and paste the dialogues into the taskGen text box. Then you can use the function “Analyze” to get a complete analysis of the linguistic features of the text. You can automatically highlight and or change font size to bring attention to those features (input enhancement)":"Utilitzeu aquesta eina per generar un diàleg. Només descriviu el vostre objectiu i una mica de context, i us proporcionarà un diàleg perfectament elaborat. Podeu copiar i enganxar els diàlegs al quadre de text de taskGen. Després podeu utilitzar la funció “Analitzar” per obtenir una anàlisi completa de les característiques lingüístiques del text. Podeu ressaltar automàticament o canviar la mida de la font per destacar aquestes característiques (millora de l’entrada)."
}
